export default [["en-us", {
  "errors": {
    "accepted": "{description} must be accepted",
    "after": "{description} must be after {after}",
    "agreementRequired": "Agreement or alternate rationale is required for upload",
    "before": "{description} must be before {before}",
    "blank": "{description} can not be blank",
    "collection": "{description} must be a collection",
    "confirmation": "{description} does not match {on}",
    "date": "{description} must be a valid date",
    "description": "This field",
    "duplicateUsername": "This username is already taken by another user account.",
    "email": "{description} must be a valid email address",
    "empty": "{description} can not be empty",
    "equalTo": "{description} must be equal to {is}",
    "even": "{description} must be even",
    "exclusion": "{description} is a duplicate",
    "greaterThan": "{description} must be greater than {gt}",
    "greaterThanOrEqualTo": "{description} must be greater than or equal to {gte}",
    "inclusion": "{description} is not included in the list",
    "invalid": "{description} is invalid",
    "invalidChangeAlertRecipients": "This list of change-alerts recipients contains invalid email addresses.",
    "lessThan": "{description} must be less than {lt}",
    "lessThanOrEqualTo": "{description} must be less than or equal to {lte}",
    "missingFile": "Missing file",
    "notANumber": "{description} must be a number",
    "notAnInteger": "{description} must be an integer",
    "odd": "{description} must be odd",
    "onOrAfter": "{description} must be on or after {onOrAfter}",
    "onOrBefore": "{description} must be on or before {onOrBefore}",
    "otherThan": "{description} must be other than {value}",
    "phone": "{description} must be a valid phone number",
    "positive": "{description} must be positive",
    "present": "{description} must be blank",
    "reportMissingAcademicYear": "Academic Year is Required",
    "reportMissingCompetency": "Competency is Required",
    "reportMissingInstructor": "Instructor is Required",
    "reportMissingInstructorGroup": "Instructor Group is Required",
    "reportMissingMeshTerm": "MeSH Term is Required",
    "reportMissingObjectForCompetency": "Association is required when Competency is the subject",
    "reportMissingObjectForInstructor": "Association is required when Instructor is the subject",
    "reportMissingObjectForInstructorGroup": "Association is required when Instructor Group is the subject",
    "reportMissingObjectForMeshTerm": "Association is required when MeSH Term is the subject",
    "reportMissingObjectForProgram": "Association is required when Program is the subject",
    "reportMissingObjectForSessionType": "Association is required when Session Type is the subject",
    "reportMissingObjectForTerm": "Association is required when Term is the subject",
    "reportMissingProgram": "Program is Required",
    "reportMissingProgramYear": "Program Year is Required",
    "reportMissingSessionType": "Session Type is Required",
    "reportMissingTerm": "Term is Required",
    "required": "{description} is required",
    "singular": "{description} can not be a collection",
    "tooLong": "{description} is too long (maximum is {max} characters)",
    "tooShort": "{description} is too short (minimum is {min} characters)",
    "url": "{description} must be a valid url",
    "wrongDateFormat": "{description} must be in the format of {format}",
    "wrongLength": "{description} is the wrong length (should be {is} characters)"
  },
  "general": {
    "aamcMethod": "AAMC Method",
    "aamcPcrs": "AAMC PCRS",
    "aamcSchoolId": "AAMC School ID (e.g. \"Institution ID\")",
    "academicLevel": "Academic Level",
    "academicLevels": "Academic Levels",
    "academicYear": "Academic Year",
    "academicYears": "Academic Years",
    "accessAllMaterialsForThisCourse": "Access All Materials for this Course",
    "accommodationIsRequiredForLearnersInSubgroups": "Accommodation is required for learners in the following subgroups: {groups}",
    "accommodationIsRequiredForLearnersInThisGroup": "Accommodation is required for learners in this group",
    "accountEnabled": "Account Enabled",
    "actions": "Actions",
    "activate": "Activate",
    "active": "Active",
    "activeFilters": "Active Filters",
    "add": "Add",
    "addCohort": "Add Cohort",
    "addNew": "Add New",
    "admin": "Admin",
    "administrator": "Administrator",
    "administratorCount": "There {count, plural, =1 {is 1 administrator} other {are # administrators}}",
    "administratorEmail": "Administrator Email",
    "administratorEmailPlaceholder": "email@example.edu",
    "administratorEmails": "Administrator Emails",
    "administrators": "Administrators",
    "advancedOptions": "Advanced Options",
    "all": "All",
    "allAcademicYears": "All Academic Years",
    "allCourses": "All Courses",
    "allEvents": "All Events",
    "allMaterials": "All Materials",
    "allOtherMembers": "All other members of {topLevelGroupTitle}",
    "allSchools": "All Schools",
    "allVocabularies": "All Vocabularies",
    "allWeeks": "All Weeks",
    "anything": "Anything",
    "apiVersionMismatch": "API Version Mismatch",
    "apiVersionMismatchDetails": "This is usually a temporary error in your browser; Ilios is in read-only mode until it is resolved. If updating does not help, please notify an administrator or technical owner of the system regarding this error. You may also wish to try a different browser.",
    "assessment": "Assessment",
    "assessmentMethods": "Assessment Methods",
    "assessmentOption": "Assessment Option",
    "assessments": "Assessments",
    "assignedTerms": "Assigned Terms",
    "associatedCourses": "Associated Courses",
    "associatedGroups": "Associated Groups",
    "associatedWith": "Associated with",
    "attendanceIsRequired": "Attendance is required",
    "attendanceIs_Required_": "Attendance is '<strong><em>'required'</em></strong>'",
    "attendanceRequired": "Attendance Required",
    "attribute": "Attribute",
    "author": "Author",
    "autoUpdatingSeconds": "{count, plural, =1 {Auto updating in 1 second...} other {Auto updating in # seconds...}}",
    "available": "Available",
    "availableCohorts": "Available Cohorts",
    "availableInstructors": "Available Instructors",
    "availableInstructorsAndInstructorGroups": "Available Instructors and Instructor Groups",
    "availableLearnerGroups": "Available Learner Groups",
    "availableLearners": "Available Learners",
    "averageHoursOfInstructionPerWeek": "Average Hours of Instruction Per Week",
    "back": "Back",
    "backToAdminDashboard": "Back to Admin Dashboard",
    "backToCalendar": "Back to Calendar",
    "backToCourse": "Back to Course",
    "backToCourses": "Back to Courses List",
    "backToDashboard": "Back to Dashboard",
    "backToDetails": "Back to Session Details",
    "backToInstructorGroups": "Back to Instructor Groups List",
    "backToProgramYear": "Back to Program Year",
    "backToProgramYears": "Back to Program Years",
    "backToPrograms": "Back to Programs",
    "backToReport": "Back to Report",
    "backToReports": "Back to Reports",
    "backToSchools": "Back to Schools",
    "backToSessionList": "Back to Session List",
    "backToTableOfContents": "Back to Table of Contents",
    "backToTitle": "Back to {title}",
    "bad": "Bad",
    "badCredentials": "Incorrect username or password",
    "beforeOrAfterMidday": "Before or after midday",
    "bottomPagination": "Bottom pagination",
    "calendar": "Calendar",
    "calendarOff": "Calendar Off",
    "calendarOn": "Calendar On",
    "campusId": "Campus ID",
    "campusNameOfRecord": "Campus name of record",
    "canNotContinueWithInvalidRecords": "Cannot continue with these invalid records, please fix and re-upload the file.",
    "canNotDeleteLearnerGroupWithAssociatedCourses": "This group is attached to {courseCount, plural, one {one course} other {# courses}} and cannot be deleted.",
    "cancel": "Cancel",
    "changeAlertRecipients": "Change-alert Recipients",
    "changeAlertRecipientsPlaceholder": "email1@example.edu, email2@example.edu",
    "childSequenceOrder": "Child Sequence Order",
    "chooseCohortTitle": "Select Parent For",
    "chooseFile": "Choose File",
    "citation": "Citation",
    "city": "City",
    "classOf": "Class of {year}",
    "clearDates": "Clear Dates",
    "clearErrors": "Clear Errors and Return to Ilios",
    "clearFilters": "Clear Filters",
    "clerkship": "Clerkship",
    "clerkshipSequenceBlocks": "Clerkship Sequence Blocks",
    "clerkshipType": "Clerkship Type",
    "clickForMore": "Click for more information",
    "clickToAddDescription": "Click to add a description.",
    "clickToAddTermDescription": "Click to add descriptive notes",
    "clickToEdit": "Click to edit",
    "close": "Close",
    "cohort": "Cohort",
    "cohortMembersNotInGroup": "Cohort Members NOT assigned to {groupTitle} ",
    "cohorts": "Cohorts",
    "cohortsManageTitle": "Manage Cohorts",
    "collapse": "collapse",
    "collapseDetail": "Hide Details",
    "color": "Color",
    "competencies": "Competencies",
    "competenciesManageTitle": "Manage Competencies",
    "competency": "Competency",
    "competencyDomain": "Competency Domain",
    "complete": "Complete",
    "completeSessions": "Sessions Complete: ready to publish",
    "confirmLogout": "You have successfully logged out of Ilios. To help protect your account and the security of others, please close all browser windows.",
    "confirmObjectiveRemoval": "Are you sure you want to delete this objective?",
    "confirmObjectiveRemovalMultipleSessionObjectives": "You are about to delete this course objective, which is linked to {count} session objectives. This will delete those relationships as well. Are you sure you want to continue?",
    "confirmRemoval": "Are you sure you want to remove this learning material?",
    "confirmRemove": "Are you sure you want to delete this offering with {learnerGroupCount} learner groups? This action cannot be undone.",
    "confirmRemoveCourse": "Are you sure you want to delete this course, with {publishedOfferingCount} published offerings? This action will remove all sessions and offerings for this course, and cannot be undone.",
    "confirmRemoveInstructorGroup": "Are you sure you want to delete this instructor group, with {instructorCount} instructors? This action cannot be undone.",
    "confirmRemoveLearnerGroup": "Are you sure you want to delete this learner group, with {subgroupCount} subgroups? This action cannot be undone.",
    "confirmRemoveProgram": "Are you sure you want to delete this program? This action cannot be undone.",
    "confirmRemoveProgramYear": "Are you sure you want to delete this program year? Doing so will also remove its associated student cohort and groups, and associations with {courseCount} course(s), and cannot be undone.",
    "confirmSessionRemoval": "Are you sure you want to delete this session?",
    "confirmVocabularyRemoval": "Are you sure you want to delete this vocabulary?",
    "connectionLost": "Connection Lost.",
    "contentAuthor": "Content Author",
    "continue": "Continue",
    "copiedIcsFeedUrl": "Copied My ICS Link successfully",
    "copiedSuccessfully": "Copied Successfully",
    "copy": "Copy",
    "copyIcsFeedUrl": "Copy My ICS Link",
    "copyLink": "Copy link",
    "copyNewToken": "Copy new token",
    "copySession": "Copy Session",
    "copySessionSummary": "You are about to copy over this session (without schedule data) into the selected course. The new session will include all objectives, terms, and learning materials.  To continue click \"done\".  To return to your current session click \"cancel\".",
    "copySuccess": "Copy Completed Successfully",
    "copyWithLearners": "Copy with Learners",
    "copyWithoutLearners": "Copy without Learners",
    "copyrightAgreement": "The file I am uploading is my own or I have express permission to reproduce and/or distribute this item, or use of it here has been assessed as allowable by the legal doctrine of Fair Use. This file does not contain protected health information, and use of it here is in compliance with Government and University policies on copyright and information security and my institution’s guidelines for professional conduct.",
    "copyrightPermission": "Copyright Permission",
    "copyrightRationale": "Copyright Rationale",
    "couldNotFindUserCampusId": "Could not find a user with the campusId {campusId}",
    "countAsOneOffering": "Count as one offering",
    "countTotal": "{total} total",
    "country": "Country",
    "course": "Course",
    "courseDirector": "Course Director",
    "courseLearningMaterials": "Course Learning Materials",
    "courseLevel": "Course Level {level}",
    "courseLevels": "Course Levels",
    "courseMaterials": "Course Materials",
    "courseNotFound": "course not found",
    "courseObjective": "Course Objective",
    "courseObjectives": "Course Objectives",
    "courseOrSessionType": "Course / Session Type",
    "courseRollover": "Rollover Course",
    "courseRolloverSuccess": "Course-Rollover Completed Successfully",
    "courseRolloverSummary": "You are about to roll over this course into the selected academic year, along with all selected options. To continue, click “Done”. To return to your current course, click “Cancel”.",
    "courseRolloverYearUnavailable": "Course Already Exists",
    "courseTitle": "Course Title",
    "courseTitleFilterPlaceholder": "Filter by course title",
    "courseTitlePlaceholder": "Enter a title for this course",
    "courseVisualizations": "Course Visualizations",
    "courseVisualizationsInstructorNoData": "{instructor} is not instructing any sessions in this this course.",
    "courseVisualizationsInstructorsGraphNoData": "No instructors have been linked to any sessions in this course.",
    "courseVisualizationsNoSessions": "This course has no sessions.",
    "courseVisualizationsSessionTypeGraphNoData": "No vocabulary terms have been linked to any {sessionType} sessions in this course.",
    "courseVisualizationsTermGraphNoData": "The vocabulary term {term} has not been linked to any sessions in this course.",
    "courseVisualizationsVocabularyGraphNoData": "No {vocabulary} vocabulary terms have been linked to any sessions in this course.",
    "courses": "Courses",
    "coursesAndSessions": "Courses and Sessions",
    "create": "Create New User",
    "createBulk": "Upload Multiple Users",
    "createNew": "Create New",
    "createNewGroup": "Create This Group",
    "currentCompetency": "Current Competency",
    "currentSchool": "Current School",
    "currentlySearchingPrompt": "searching...",
    "curriculumInventory": "Curriculum Inventory",
    "curriculumInventoryInstitutionalInfo": "Curriculum Inventory Institutional Information",
    "curriculumInventoryReport": "Curriculum Inventory Report",
    "curriculumInventoryReportRollover": "Rollover Report",
    "curriculumInventoryReportRolloverSuccess": "Report-Rollover Completed Successfully",
    "curriculumInventoryReportRolloverSummary": "This action will copy the structure of this report to be used in your target year. It will not copy course information, only the higher level sequence block structure. You will need to add the appropriate course information and modify the sequence block start and end dates once you have rolled over the existing report structure.",
    "curriculumInventoryReports": "Curriculum Inventory Reports",
    "dashboard": "Dashboard",
    "dashboardNavigation": "Dashboard navigation",
    "date": "Date",
    "dateTime": "Date/Time",
    "day": "Day",
    "deactivate": "Deactivate",
    "defaultInstructors": "Default Instructors",
    "defaultInstructorsNotLoaded": "(Default Instructors will not be loaded: please enter desired value.)",
    "defaultLocation": "Default Location",
    "defaultLocationNotLoaded": "(Default Location will not be loaded: please enter desired value.)",
    "defaultNotLoaded": "Default Not Loaded",
    "defaultVirtualLearningLink": "Default Virtual Learning Link",
    "delete": "Delete",
    "deleteCourse": "Delete Course",
    "departments": "Departments",
    "deprecatedAbbreviation": "depr.",
    "description": "Description",
    "deselectUser": "Deselect User",
    "details": "Course Details",
    "developer": "Developer",
    "director": "Director",
    "directorCount": "There {count, plural, =1 {is 1 director} other {are # directors}}",
    "directors": "Directors",
    "disableUser": "Disable User",
    "disabled": "disabled",
    "displayName": "Display Name",
    "doesNotMatchUserRecord": "Uploaded {description} does not match the information in Ilios, which is \"{record}\"",
    "domain": "Domain",
    "done": "Done",
    "download": "Download",
    "downloadCompetencyMap": "Download Competency Map",
    "downloadResults": "Download Results",
    "draft": "Draft",
    "dueBefore": "Due Before",
    "dueBy": "Due By",
    "duePriorTo": "Due prior to",
    "duration": "Duration",
    "durationHours": "{count, plural, =1 {1 hour} other {# hours}}",
    "durationInDays": "Duration (in Days)",
    "durationInYears": "Duration (in Years)",
    "durationMinutes": "{count, plural, =1 {1 minute} other {# minutes}}",
    "edit": "Edit",
    "educationalYear": "Educational Year",
    "email": "Email",
    "emails": "Emails",
    "enabled": "Enabled",
    "end": "End",
    "endDate": "End Date",
    "endLevel": "End Level",
    "endTime": "End Time",
    "ends": "Ends",
    "error": "Error",
    "errorDisplayMessage": "Sorry! Something went wrong with your request. Please try refreshing or check back later.",
    "errorSavingAuthentication": "Accounts were created for these users, but they will not be able to login.  This usually happens when the username already exists, but belongs to another user.  Please click on each user in the list and create a username and password for them.",
    "errorSavingUser": "These users were unable to be saved.  Please verify that they do not already exist.",
    "errors": "Errors",
    "etAl": "et al.",
    "eventNotFoundExplanation": "The event you have tried to reach is either no longer available, or you have followed a personalized user link which is not shareable. If you continue to encounter issues, please contact your Ilios help desk.",
    "eventNotFoundTitle": "Event Not Found",
    "exclude": "Exclude",
    "excludeFromSync": "Exclude From Sync",
    "existingGroup": "Existing Group",
    "expand": "expand",
    "expandDetail": "Show Details",
    "externalId": "Course ID",
    "file": "File",
    "file-audio": "Audio file",
    "file-pdf": "PDF file",
    "file-powerpoint": "PowerPoint file",
    "file-video": "Video file",
    "fileSizeError": "This file is too large.  Maximum size is {maxSize}.",
    "fileTypeError": "Bad file type: {fileType} does not appear to be a properly delimited file.",
    "fileUploadError": "We were unable to upload this file.  Please ensure you are connected to the network.  If this problem persists please let us know.",
    "filterByNameOrEmail": "Filter by name or email",
    "filterByProgram": "Filter by Program",
    "filterBySchool": "Filter by School",
    "filterByTitle": "Filter by Title",
    "filterByYear": "Filter by Year",
    "filterChartPlaceholder": "Start typing to filter this chart",
    "filterPlaceholder": "Start typing to filter list",
    "finalErrorDisplayMessage": "Zoinks! Something is very wrong. Please refresh your browser and let us know at support@iliosproject.org if you continue to see this message.",
    "finalResults": "Final Results",
    "finalize": "Finalize",
    "finalizeReportConfirmation": "By finalizing this report, you will be saving it in its current state to the Ilios database as a permanent reference object, and no further edits will be possible.",
    "finalized": "Finalized",
    "finalizingReport": "Finalizing report, this may take a while...",
    "findDirector": "Find Director",
    "findInstructorOrGroup": "Find Instructor or Group",
    "findLearners": "Find Learners",
    "first": "First",
    "firstName": "First Name",
    "firstOffering": "First Offering",
    "for": "For",
    "formative": "Formative",
    "formerStudent": "Former Student",
    "forward": "Forward",
    "friday": "Friday",
    "fullName": "Full Name",
    "globalSearchPlaceholder": "Find Users...",
    "go": "Go",
    "goToNextYear": "Go to next year",
    "goToPreviousYear": "Go to previous year",
    "goToUser": "Show user record in ilios",
    "good": "Good",
    "groupByCompetencies": "Group by Competencies",
    "groupMembers": "Members of current group",
    "groupName": "Group Name",
    "groups": "Groups",
    "hideCalendar": "Hide Calendar",
    "hideCourseMaterials": "Hide course materials",
    "hideFilters": "Hide Filters",
    "hideIcsFeed": "Hide ICS Feed Options",
    "hideObjectives": "Hide objectives",
    "hideRolesInCourses": "Hide roles in courses",
    "hideRolesInProgramYears": "Hide roles in program years",
    "hideRolesInPrograms": "Hide roles in programs",
    "hideRolesInSessions": "Hide roles in sessions",
    "hideSessionMaterials": "Hide session materials",
    "home": "Home",
    "hour": "Hour",
    "hours": "Hours",
    "icsAdminInstructions": "To add a user's Ilios calendar to another application or service, they will need to use this URL.  This URL is like a password. Anyone who knows it can view this user's calendar!",
    "icsFeed": "ICS Feed",
    "icsInstructions": "To add your Ilios calendar to another application or service, use this URL.  This URL is like a password. Anyone who knows it can view your calendar!",
    "id": "ID",
    "ignore": "Ignore",
    "ilios": "Ilios",
    "iliosUpdatePending": "Huzzah! We've made Ilios better. You will get the new stuff on your next login, or click to update now.",
    "iliosUserGuide": "Ilios User Guide",
    "ilm": "ILM",
    "ilmDue": "ILM - Due",
    "in": "in",
    "inProgress": "In Progress",
    "inactive": "inactive",
    "include": "Include",
    "includedInGrade": "Included in Grade",
    "incompleteSessions": "Sessions Incomplete: cannot publish",
    "independentLearning": "Independent Learning",
    "independentLearningActivities": "Independent Learning Activities",
    "instructing": "Instructing",
    "instructionalMethod": "Instructional Method",
    "instructionalMethods": "Instructional Methods",
    "instructionalNotes": "Instructional Notes",
    "instructor": "Instructor",
    "instructorGroup": "Instructor Group",
    "instructorGroupMembers": "Instructor Group Members",
    "instructorGroupTitle": "Instructor Group Title",
    "instructorGroupTitleFilterPlaceholder": "Filter by Instructor Group Title",
    "instructorGroupTitlePlaceholder": "Enter a title for this instructor group",
    "instructorGroups": "Instructor Groups",
    "instructors": "Instructors",
    "instructorsAndInstructorGroups": "Instructors and Instructor Groups",
    "instructorsAndInstructorGroupsWithCount": "Instructors ({instructorCount}) and Instructor Groups ({instructorGroupCount})",
    "instructorsManageTitle": "Manage Instructors",
    "invalidDatetimes": "Invalid dates/times",
    "invalidUsers": "Invalid Users",
    "invalidateTokens": "Invalidate All Tokens",
    "invalidateTokensConfirmation": "This will invalidate all existing API tokens and you will need to generate new ones for any applications you have.  Are you sure you want to do this?",
    "isSelective": "Is Selective",
    "isTrack": "Is Track",
    "itemCode": "Item Code",
    "language": {
      "en-us": "English (en)",
      "es": "Español (es)",
      "fr": "Français (fr)"
    },
    "last": "Last",
    "lastName": "Last Name",
    "lastUpdate": "Last Update",
    "leadership": "Leadership",
    "learner": "Learner",
    "learnerAssignments": "{groupTitle} Learner Assignments",
    "learnerGroupTitle": "Learner Group Title",
    "learnerGroupTitleFilterPlaceholder": "Filter by Learner Group Title",
    "learnerGroupTitlePlaceholder": "Enter a title for this learner group",
    "learnerGroups": "Learner Groups",
    "learnerGroupsManageTitle": "Manage Learner Groups",
    "learners": "Learners",
    "learnersAndLearnerGroups": "Learners and Learner Groups",
    "learnersAndLearnerGroupsWithCount": "Learners ({learnerCount}) and Learner Groups ({learnerGroupCount})",
    "learning": "Learning",
    "learningMaterial": "Learning Material",
    "learningMaterialManageTitle": "Manage Learning Material",
    "learningMaterials": "Learning Materials",
    "learningMaterialsSummary": "Learning Materials Summary",
    "level": "Level",
    "link": "Web Link",
    "linkedCompetencies": "Linked Competencies",
    "linkedCompetencyCount": "{count, plural, =1 {1 has a linked competency} other {# have linked competencies}}",
    "listByPriority": "List by Priority",
    "lmDescriptorTitle": "Select MeSH Descriptors for Learning Materials",
    "loading": "Loading Ilios",
    "loadingEvents": "Loading Events",
    "loadingMaterials": "Loading Materials...",
    "loadingSessionTypes": "Loading Session Types...",
    "location": "Location",
    "lockCourse": "Lock Course",
    "login": "Login",
    "logo": "Ilios Logo",
    "logout": "Logout",
    "makeRecurring": "Make Recurring",
    "manage": "Manage",
    "manageAPITokens": "Manage API Tokens",
    "manageCompetencies": "Manage Competencies",
    "manageDefaultInstructors": "Manage Default Instructors",
    "manageEmails": "Manage Emails",
    "manageGroupMembership": "Manage Group Membership",
    "manageInstitutionalInfo": "Manage CIR Institutional Info",
    "manageLeadership": "Manage Leadership",
    "manageLearners": "Manage Learners",
    "manageSessionAttributes": "Manage Session Attributes",
    "manageUsers": "Manage Users",
    "manageUsersSummaryTitle": "Ilios Users",
    "manageVocabularies": "Manage Vocabularies",
    "markAsScheduled": "Mark as Scheduled",
    "matchGroups": "Match Groups",
    "materials": "Materials",
    "matriculationYear": "Matriculation Year",
    "maximum": "Maximum",
    "members": "Members",
    "menu": "Ilios Menu",
    "mesh": "MeSH",
    "meshCount": "{count, plural, =1 {1 has MeSH} other {# have MesH}}",
    "meshManageTitle": "Manage MeSH",
    "meshTerm": "MeSH Term",
    "meshTerms": "MeSH Terms",
    "message": "Message",
    "middleName": "Middle Name",
    "minimum": "Minimum",
    "minute": "Minute",
    "minutes": "Minutes",
    "missingCohortMessage": "Please add at least one cohort to this course.",
    "missingCompetenciesMessage": "Please add at least one competency to this program year.",
    "missingCourseObjectivesMessage": "Please add at least one objective to the course.",
    "missingItems": "Missing Items",
    "missingPassword": "Password required",
    "missingRequiredUsername": "'Username' is required for login; this user will be unable to login until a username is entered.",
    "missingUsername": "Username required",
    "modifyUserPassword": "Click here to reset password.",
    "monday": "Monday",
    "month": "Month",
    "moreInputRequiredPrompt": "keep typing...",
    "moveToGroup": "{count, plural, =1 {Move learner to {groupTitle}} other {Move # learners to {groupTitle}}}",
    "multiDay": "Multi Day",
    "multiday": "Multiday",
    "multidayEvents": "Multiday Events",
    "multiple": "Multiple",
    "multipleGroups": "Multiple Groups",
    "multipleUsersFoundWithCampusId": "Multiple users found with the campusId {campusId}",
    "mustBeSameDayOfWeekAsCurrentStartDate": "Must be same day of week as current start date",
    "myCalendar": "My Calendar",
    "myCourses": "My Courses",
    "myLearningMaterials": "My Learning Materials",
    "myMaterials": "My Materials",
    "myProfile": "My Profile",
    "mySchedule": "My Schedule",
    "name": "Name",
    "narrative": "Narrative",
    "navigation": "Navigation",
    "navigationCompleteText": "Ilios page navigation is complete. You may now navigate the page content as you wish.",
    "newCourse": "New Course",
    "newCurriculumInventoryReport": "New Curriculum Inventory Report",
    "newDomain": "New Domain",
    "newInstructorGroup": "New Instructor Group",
    "newLearnerGroup": "New Learner Group",
    "newObjective": "New Objective",
    "newObjectiveSaved": "New Objective Saved",
    "newOffering": "New Offering",
    "newProgram": "New Program",
    "newProgramYear": "New Program Year",
    "newReport": "New Report",
    "newSchool": "New School",
    "newSequenceBlock": "New Sequence Block",
    "newSession": "New Session",
    "newTerm": "New Term",
    "newToken": "New Token",
    "newUpdates": "new updates",
    "newUser": "New User",
    "newUsersCreatedSuccessfully": "New users created successfully",
    "newUsersCreatedWarning": "Some users were created, but there were errors.",
    "next": "Next",
    "nextXDays": "Next {days} days",
    "no": "No",
    "noAccountExists": "Your account {accountName} does not match any user records in Ilios. If you need further assistance, please contact your school’s Ilios administrator.",
    "noAssociatedCompetencies": "No Associated Competencies",
    "noAssociatedCompetency": "No Associated Competency",
    "noAvailableCohorts": "No available cohorts",
    "noAvailableLearnerGroups": "No learner groups available; No cohort is attached to this course.",
    "noAvailableLearners": "No learners available; No cohort is attached to this course.",
    "noCohorts": "There are no cohorts in this course",
    "noCohortsAvailableForStudentAssignment": "There are no cohorts available for student assignment in this school.",
    "noCourseLearningMaterialsAvailable": "No Course Learning Materials Available",
    "noCourses": "There are no courses in this school",
    "noCurriculumInventoryInstitutionalInfo": "No institutional information has been configured for this school.",
    "noEvents": "No Events",
    "noLearnerGroups": "No learner groups",
    "noOfferingLearnerGroups": "No Groups",
    "noOfferings": "This session has no offerings",
    "noPermissionsInOtherSchools": "You do not have the necessary permissions to modify access for this user in any other schools.",
    "noPopulateGroup": "No!  Leave it empty, I'll add students myself.",
    "noPrintDraft": "Courses which are in draft status cannot be printed",
    "noProgramYears": "There are no program years in this program",
    "noResultsFound": "No results found. Please try again.",
    "noSearchResults": "Your search did not return any results",
    "noSearchResultsPrompt": "no results",
    "noSelectedCompetencies": "There are no selected competencies",
    "noSelectedLearnerGroups": "There are no selected learner groups",
    "noSequenceBlocks": "There are no sequence blocks in this report.",
    "noSessionLearningMaterialsAvailable": "No Session Learning Materials Available",
    "noSessions": "There are no sessions in this course",
    "noSubSequenceBlocks": "This sequence block has no nested sequence blocks.",
    "noSubgroups": "There are no subgroups in this learner group",
    "noUnselectedCompetencies": "There are no unselected competencies",
    "noUnselectedLearnerGroupsInCohort": "There are no unselected learner groups in this cohort",
    "nonClerkshipSequenceBlocks": "Non-Clerkship Sequence Blocks",
    "nonStudent": "Non-Student",
    "none": "None",
    "notAClerkship": "Not a Clerkship",
    "notApplicableAbbr": "n/a",
    "notFoundMessage": "Rats! I couldn't find that. Please check your page address, and try again.",
    "notPublished": "Not Published",
    "notStarted": "Not Started",
    "notes": "Notes",
    "numberOfEvents": "Number of Events",
    "numberOfEventsFeaturingThisAsThePrimaryMethod": "Number of Events Featuring This as the Primary Method",
    "numberOfExams": "Number of Exams",
    "numberOfFormalInstructionalHoursPerCourse": "Number of Formal Instructional Hours Per Course",
    "numberOfFormativeAssessments": "Number of Formative Assessments",
    "numberOfGroups": "Number of Groups",
    "numberOfGroupsToGenerate": "Number of groups to generate.",
    "numberOfNonPrimaryOccurrencesOfThisMethod": "Number of Non-Primary Occurrences of This Method",
    "numberOfSummativeAssessments": "Number of Summative Assessments",
    "objective": "Objective",
    "objectiveCompetencyManagerTitle": "Select Parent Competency for Objective",
    "objectiveCount": "There {count, plural, =1 {is 1 objective} other {are # objectives}}",
    "objectiveDescriptorTitle": "Select MeSH Descriptors for Objective",
    "objectiveMap": "Objective Map",
    "objectiveParentTitle": "Select Parent Objectives",
    "objectiveParentTitleSingular": "Select Parent Objective",
    "objectiveParentsTitle": "Select Parent Objectives",
    "objectiveTitle": "Session Objective",
    "objectives": "Objectives",
    "objectivesWithNoHours": "The following course objectives are either not linked to any session, or only linked to sessions without offering or duration data.",
    "objectivesWithNoLink": "No Course Objectives Currently Linked to Instructional Time.",
    "off": "Off",
    "offering": "Offering",
    "offerings": "Offerings",
    "ok": "OK",
    "on": "On",
    "openSmallGroupGenerator": "Open Offering Small Group Generator",
    "optional": "Optional",
    "optionalElective": "Optional (elective)",
    "orderInSequence": "Order in Sequence",
    "ordered": "Ordered",
    "other": "Other",
    "otherId": "Other ID",
    "otherVisualizations": "Other Visualizations",
    "overview": "Overview",
    "ownedBy": "owned by {owner}",
    "owner": "Owner",
    "pagedResultsCount": "Showing {start} - {end} of {total}",
    "parallel": "Parallel",
    "parentCount": "{count, plural, =1 {1 has a parent} other {# have parents}}",
    "parentGroup": "Parent group",
    "parentGroups": "Parent groups",
    "parentObjectives": "Parent Objectives",
    "password": "Password",
    "pendingUpdatesSummary": "{count, plural, =1 {There is one user needing attention} other {There are # users needing attention}}",
    "pendingUpdatesSummaryTitle": "Updates from the Campus Directory",
    "pendingUserUpdates": {
      "emailMismatch": "The email address in the directory ({value}) does not match the email in ilios ({email}).",
      "filterBy": "Filter by user name",
      "missingFromDirectory": "Unable to find user in the directory, please update, disable, or exclude their account from synchronization.",
      "updateIlios": "Update Ilios"
    },
    "people": "People",
    "perPage": "Per Page",
    "percentage": "Percentage",
    "performsNonLearnerFunctions": "Performs Non-Learner Functions",
    "permissions": "Permissions",
    "permissionsInOtherSchools": "Permissions in Other Schools",
    "phasesStartToEnd": "Phases (Start - End)",
    "phone": "Phone",
    "physicianCompetencyReferenceSet": "Physician Competency Reference Set",
    "physicianCompetencyReferenceSetAbbr": "PCRS",
    "pickADate": "Pick a date",
    "populateGroup": "Do you want to auto-populate this group?",
    "preWork": "Pre-work",
    "preferredEmail": "Preferred Email",
    "prerequisites": "Prerequisites",
    "prev": "Prev",
    "previous": "Previous",
    "primary": "Primary",
    "primaryCohort": "Primary Cohort",
    "primarySchool": "Primary School",
    "printSummary": "Print Summary",
    "program": "Program",
    "programAndCohort": "Program / Cohort",
    "programCohorts": "Program Cohorts",
    "programDetail": "Program Detail",
    "programExpectations": "Program Expectations",
    "programExpectationsId": "Program Expectations ID",
    "programLeadership": "Program Leadership",
    "programTitle": "Program Title",
    "programTitleFilterPlaceholder": "Filter by Program Title",
    "programTitlePlaceholder": "Enter a title for this program",
    "programTitleShort": "Title (short)",
    "programYear": "Program Year",
    "programYearLeadership": "Program Year Leadership",
    "programYearVisualizations": "Program Year Visualizations",
    "programYears": "Program Years",
    "programs": "Programs",
    "promoteToPrimaryCohort": "Promote to primary cohort",
    "pronouns": "Pronouns",
    "publicationStatus": "Publication Status",
    "publishAllConfirmation": "Publish {publishCount}, schedule {scheduleCount}, and ignore {ignoreCount} sessions",
    "publishAllSessions": "Publish {sessionCount} sessions",
    "publishAsIs": "Publish As-is",
    "publishCourse": "Publish Course",
    "publishProgram": "Publish Program",
    "publishProgramYear": "Publish Program Year",
    "publishSession": "Publish Session",
    "published": "Published",
    "publishedSuccessfully": "Published Successfully",
    "read": "Read",
    "reconnectNow": "Reconnect Now",
    "reconnectionSeconds": "{count, plural, =1 {Reconnecting in 1 second...} other {Reconnecting in # seconds...}}",
    "refreshIcsFeedKey": "Refresh the ICS Feed key for this user",
    "refreshTheBrowser": "Refresh the Browser",
    "remove": "Remove",
    "removeAll": "Remove All",
    "removeCohort": "Remove Cohort",
    "removeLearnerToCohort": "{count, plural, =1 {Remove learner to {cohort}} other {Remove # learners to {cohort}}}",
    "removePrimaryCohort": "Remove Primary Cohort",
    "removedSuccessfully": "Removed Successfully",
    "reportConfirmRemove": "Are you sure you want to delete this report? This action cannot be undone.",
    "reportDescriptionPlaceholder": "Please enter a brief description about this report.",
    "reportDisplayDescriptionWithObject": "This report shows all {subject} associated with {objectType} \"{object}\" {year} in {school}.",
    "reportDisplayDescriptionWithoutObject": "This report shows all {subject} in {school}.",
    "reportDisplayTitleWithObject": "All {subject} for {object} in {school}",
    "reportDisplayTitleWithoutObject": "All {subject} in {school}",
    "reportName": "Report Name",
    "reportNamePlaceholder": "Please enter a report name.",
    "reportTitle": "Report Title",
    "reports": "Reports",
    "required": "Required",
    "requiredInTrack": "Required In Track",
    "resourceTypes": "Resource Types",
    "results": "Results",
    "resultsCount": "{count, plural, =1 {1 result} other {# results}}",
    "returnToPreviousPage": "Return to Previous Page",
    "reviewMissingItems": "Review {count} Missing Items",
    "reviewSessions": "Sessions Requiring Review",
    "root": "Root",
    "runReport": "Run Report",
    "sampleFile": "Sample File",
    "saturday": "Saturday",
    "save": "Save",
    "saved": "New User Saved Successfully",
    "savedSuccessfully": "Saved Successfully",
    "scheduled": "Scheduled",
    "scheduledSuccessfully": "Scheduled Successfully",
    "scheduling": "Scheduling",
    "school": "School",
    "schoolName": "School Name",
    "schools": "Schools",
    "search": "Search",
    "searchDirectory": "Search directory for new users",
    "searchForIliosUsers": "Find Ilios Users...",
    "searchMesh": "Search MeSH",
    "searchPlaceholder": "Find Learning Material",
    "searchTheCurriculum": "Search the curriculum",
    "searchUsers": "Search for users",
    "secondaryCohorts": "Secondary Cohorts",
    "select": "Select",
    "selectAcademicYear": "Select Academic Year",
    "selectAllOrNone": "Select All or None",
    "selectCohortsToAttach": "Select the cohort of students you wish to attach to the new course",
    "selectCourse": "Select a Course",
    "selectMeshFor": "Select MeSH for: {title}",
    "selectPolite": "(please select one)",
    "selectProgram": "Select a Program",
    "selectSchool": "Select School",
    "selectUser": "Select User",
    "selectVocabulary": "Select Vocabulary",
    "selectYear": "Select Educational Year",
    "selected": "Selected",
    "selectedInstructorGroups": "Selected Instructor Groups",
    "selectedInstructors": "Selected Instructors",
    "selectedLearnerGroups": "Selected Learner Groups",
    "selectedLearners": "Selected Learners",
    "sequenceBlock": "Sequence Block",
    "sequenceBlockConfirmRemove": "Are you sure you want to delete this sequence block? This action cannot be undone.",
    "sequenceBlockDescriptionPlaceholder": "Please enter a description for this sequence block.",
    "sequenceBlockIsSelective": "This sequence block has been marked as a selective.",
    "sequenceBlockTitlePlaceholder": "Please enter a title for this sequence block.",
    "sequenceBlocks": "Sequence Blocks",
    "sequenceNumber": "Sequence #",
    "session": "Session",
    "sessionAttributes": "Session Attributes",
    "sessionLearningMaterials": "Session Learning Materials",
    "sessionTitle": "Session Title",
    "sessionTitleFilterPlaceholder": "Filter by title, type, or status",
    "sessionTitlePlaceholder": "Enter a title for this session",
    "sessionType": "Session Type",
    "sessionTypeConfirmRemoval": "Are you sure you want to delete this session type? This action cannot be undone.",
    "sessionTypes": "Session Types",
    "sessionTypesFor": "Session Types for {subject}",
    "sessions": "Sessions",
    "showAllMyActivities": "Show all my activities",
    "showCalendar": "Show Calendar",
    "showCourseMaterials": "Show course materials",
    "showFilters": "Show Filters",
    "showIcsFeed": "Show ICS Feed Options",
    "showLearnerGroupEvents": "Show all events for assigned learner groups",
    "showMore": "Show more",
    "showNotesToStudents": "Show Notes to Students",
    "showObjectives": "Show objectives",
    "showOnlyMyAdminActivities": "Show only my admin activities",
    "showOnlyMyInstructorActivities": "Show only my instructor activities",
    "showOnlyMyLearnerActivities": "Show only my learner activities",
    "showResultsFor": "Show Results For",
    "showRolesInCourses": "Show roles in courses",
    "showRolesInProgramYears": "Show roles in program years",
    "showRolesInPrograms": "Show roles in programs",
    "showRolesInSessions": "Show roles in sessions",
    "showSessionEvents": "Show all other '<em>'{sessionTitle}'</em>' events",
    "showSessionMaterials": "Show session materials",
    "showSubgroupEvents": "Show events for all subgroups",
    "singleDay": "Single Day",
    "singleGroup": "Single Group",
    "skipToMainContent": "Skip to main content",
    "smallGroupMessage": "Please select at least one learner group to attach to your small group offering. If you wish to schedule this offering without groups, please select the \"offering\" button above.",
    "smallGroups": "Small Groups",
    "sortMaterials": "Sort Materials",
    "sortObjectives": "Sort Objectives",
    "specialAttireIs_Required_": "Special Attire is '<strong><em>'required'</em></strong>'",
    "specialAttireRequired": "Special Attire Required",
    "specialEquipment": "Special Equipment",
    "specialEquipmentIs_Required_": "Special Equipment is '<strong><em>'required'</em></strong>'",
    "specialEquipmentRequired": "Special Equipment Required",
    "start": "Start",
    "startDate": "Start Date",
    "startLevel": "Start Level",
    "startOver": "Start Over",
    "startTime": "Start Time",
    "starts": "Starts",
    "stateOrProvince": "State or Province",
    "status": "Status",
    "statusCode": "Status Code",
    "stewardingSchoolsAndDepartments": "Stewarding Schools and Departments",
    "stewardsManageTitle": "Manage Stewards",
    "street": "Street",
    "strong": "Strong",
    "student": "Student",
    "studentAdvisorCount": "There {count, plural, =1 {is 1 student advisor} other {are # student advisors}}",
    "studentAdvisors": "Student Advisors",
    "subCompetencyCount": "{count, plural, =1 {There is 1 subcompetency} other {There are # subcompetencies}}",
    "subTerms": "Sub-terms",
    "subgroupName": "Subgroup Name",
    "subgroups": "Subgroups",
    "subjectReports": "Subject Reports",
    "successfullyAddedTerm": "Term Added Successfully",
    "successfullyInvalidatedTokens": "All existing tokens were successfully invalidated",
    "successfullyRemovedTerm": "Term Deleted Successfully",
    "summary": "Summary",
    "sunday": "Sunday",
    "supplementalCurriculum": "Supplemental Curriculum",
    "table1ProgramExpectationsMappedToPcrs": "Table 1: Program Expectations Mapped to PCRS",
    "table2PrimaryInstructionalMethodByNonClerkshipSequenceBlock": "Table 2: Primary Instructional Method by Non-Clerkship Sequence Block",
    "table3aNonClerkshipSequenceBlockInstructionalTime": "Table 3-A: Non-Clerkship Sequence Block Instructional Time",
    "table3bClerkshipSequenceBlockInstructionalTime": "Table 3-B: Clerkship Sequence Block Instructional Time",
    "table4InstructionalMethodCounts": "Table 4: Instructional Method Counts",
    "table5NonClerkshipSequenceBlockAssessmentMethods": "Table 5: Non-Clerkship Sequence Block Assessment Methods",
    "table6ClerkshipSequenceBlockAssessmentMethods": "Table 6: Clerkship Sequence Block Assessment Methods",
    "table7AllEventsWithAssessmentsTaggedAsFormativeOrSummative": "Table 7: All Events with Assessments Tagged as Formative or Summative",
    "table8AllResourceTypes": "Table 8: All Resource Types",
    "targetCourse": "Target Course",
    "taughtBy": "Taught By {instructors}",
    "term": "Term",
    "termCount": "{count, plural, =1 {1 has vocabulary terms} other {# have vocabulary terms}}",
    "termXappliedToYSessionsWithSessionTypeZ": "The term \"{term}\" from the \"{vocabulary}\" vocabulary is applied to {sessionsCount, plural, =1 {1 session} other {# sessions}} with session-type \"{sessionType}\".",
    "terms": "Terms",
    "termsBySessionType": "Terms by Session Type",
    "termsManageTitle": "Manage Terms",
    "thereAreXTerms": "{count, plural, =1 {There is 1 term} other {There are # terms}}",
    "thereAreXTypes": "{count, plural, =1 {There is 1 type} other {There are # types}}",
    "thisReportIsNoLongerAvailable": "This report is no longer available.",
    "thisTermHasSubTerms": "This term has sub-terms.",
    "thursday": "Thursday",
    "time": "Time",
    "timedRelease": "Timed Release",
    "timedReleaseAddEndDate": "Add End Date",
    "timedReleaseAddStartDate": "Add Start Date",
    "timedReleaseClearEndDate": "Clear End Date",
    "timedReleaseClearStartDate": "Clear Start Date",
    "timedReleaseNoSchedule": "Available immediately when published",
    "timedReleaseOnlyEndDate": "Available until {endDate}",
    "timedReleaseOnlyStartDate": "Available: {startDate}",
    "timedReleaseStartAndEndDate": "Available: {startDate} until {endDate}",
    "timezone": "Timezone",
    "title": "Title",
    "today": "Today",
    "token": "Token",
    "tokenInfo": "API Tokens are used to programmatically access Ilios data.  Your token is like a password - anyone who has it can make changes on your behalf.  Read more in the documentation at {apiDocsLink}.",
    "tooManyResults": "Search returned more than {count} results.  To see better results try your search again with more terms.",
    "topPagination": "Top pagination",
    "total": "Total",
    "totalErrors": "{count, plural, =1 {There is an error} other {There are # errors}}",
    "totalIlmTime": "Total ILM Time {minutes} Minutes",
    "totalInstructionalTime": "Total Instructional Time {minutes} Minutes",
    "totalTime": "Total time",
    "totalWeeks": "Total Weeks",
    "transitionErrorMessage": "Sorry, we can’t get you where you asked to go: something seems to be broken...",
    "tryHarder": "Try Harder",
    "tuesday": "Tuesday",
    "type": "Type",
    "unPublishCourse": "UnPublish Course",
    "unPublishProgram": "UnPublish Program",
    "unPublishProgramYear": "UnPublish Program Year",
    "unPublishSession": "UnPublish Session",
    "unPublishedSuccessfully": "UnPublished Successfully",
    "unableToReconnect": "Unable to Reconnect!",
    "unableToSyncUser": "Unable to sync user from directory, please ensure the Campus ID is correct.",
    "unassigned": "Unassigned",
    "unassignedStudentsConfirmation": "{count, plural, =1 {Assign 1 selected user to} other {Assign # selected users to}}",
    "unassignedStudentsSummary": "{count, plural, =1 {There is one student needing assignment to a cohort} other {There are # students needing assignment to a cohort}}",
    "unassignedStudentsSummaryTitle": "Students Requiring Cohort Assignment",
    "undo": "Undo",
    "universalLocator": "Universal Locator",
    "unlinkedObjectives": "This course has unlinked objective(s)",
    "unlockCourse": "Unlock course",
    "unordered": "Unordered",
    "unsupportedBrowserFailure": "Your browser is not officially supported by Ilios and cannot complete this action. Please try again using an up-to-date browser.",
    "unusedObjectives": "Unused Objectives",
    "upcomingActivities": "My Activities for the next {days} days",
    "upcomingMaterials": "My Learning Materials for the next {days} days",
    "update": "Update",
    "updateNow": "Update Now",
    "updatePending": "Update Pending",
    "updateUserFromDirectory": "Update this user record from the campus directory.",
    "uploadDate": "Upload date",
    "uploadGroupAssignments": "Upload Group Assignments",
    "uploadUsers": "File with user data (csv, tsv, txt)",
    "uploadedGroup": "Uploaded Group",
    "url": "URL",
    "userExistsInGroupHierarchy": "User already exists in top-level group {groupTitle} or one of its subgroups.",
    "userExistsMultipleTimesInUpload": "This user already exists in the upload.",
    "userMenu": "User menu",
    "userNotAddableFromDirectory": "This user is missing required information and cannot be added",
    "userNotInGroupCohort": "User is not in this group's cohort: {cohortTitle}",
    "userRole": "User Role",
    "userRoles": "User Roles",
    "username": "Username",
    "users": "Users",
    "usersCalendar": "{name}'s Calendar",
    "usersSelected": "{count, plural, =1 {1 user selected} other {# users selected}}",
    "validUntil": "When should this token stop working?",
    "validUsers": "Valid Users",
    "verificationPreviewFor": "Verification Preview for {name}",
    "view": "View",
    "viewAll": "View All",
    "virtualLearningLink": "Virtual Learning Link",
    "virtualSessionLink": "Virtual Session Link",
    "visibleToStudents": "Visible to Students",
    "visualizations": "Visualizations",
    "visualizeCourseObjectives": "Visualize course objectives",
    "vocabularies": "Vocabularies",
    "vocabulariesBySessionType": "Vocabularies by Session Type",
    "vocabulary": "Vocabulary",
    "vocabularyTerms": "Vocabulary Terms",
    "vocabularyTermsFor": "Vocabulary Terms for {subject}",
    "waitSaving": "saving... one moment...",
    "weak": "Weak",
    "wednesday": "Wednesday",
    "week": "Week",
    "weekAtAGlance": "Week at a Glance",
    "weekOf": "Week of {date}",
    "weeks": "Weeks",
    "when": "When",
    "whichIs": "which is",
    "whitecoatsSlashSpecialAttire": "Whitecoats / special attire",
    "withXmoreOfferings": "with {count, plural, =1 {one more offering} other {# more offerings}}",
    "write": "Write",
    "xTermsFromVocabYusedWithSessionTypeZ": "{termsCount, plural, =1 {1 term} other {# terms}} from the \"{vocabulary}\" vocabulary {termsCount, plural, =1 {is} other {are}} applied to {sessionsCount, plural, =1 {1 session} other {# sessions}} with session-type \"{sessionType}\".",
    "year": "Year",
    "yes": "Yes",
    "yesPopulateGroup": "Yes!  Add entire cohort to my new group.",
    "zipCode": "ZIP Code"
  }
}], ["es", {
  "errors": {
    "accepted": "{description} debe ser aceptado",
    "after": "{description} necesita estar después de {after}",
    "agreementRequired": "Acuerdo o se requiere una justificación alternativa para cargar",
    "before": "{description} necesita estar antes de {before}",
    "blank": "{description} no puede estar en blanco",
    "collection": "{description} necesita ser una colección",
    "confirmation": "{description} no coincide con {on}",
    "date": "{description} necesita estar una fecha válida",
    "description": "Este campo",
    "duplicateUsername": "Este nombre de usuario ya está ocupado por otra cuenta de usuario.",
    "email": "{description} debe ser una dirección válida de correo electrónico",
    "empty": "{description} no puede estar vacío",
    "equalTo": "{description} debe ser igual a {is}",
    "even": "{description} debe ser número par",
    "exclusion": "{description} es reservado",
    "greaterThan": "{description} debe ser mayor que {gt}",
    "greaterThanOrEqualTo": "{description} debe ser mayor que o igual a {gte}",
    "inclusion": "{description} no está incluido en la lista",
    "invalid": "{description} es inválido",
    "invalidChangeAlertRecipients": "Esta lista de destinatarios de alertas de cambios contiene direcciones de correo electrónico no válidas.",
    "lessThan": "{description} debe ser menos que {lt}",
    "lessThanOrEqualTo": "{description} debe ser menos que o igual a {lte}",
    "missingFile": "Archivo faltante",
    "notANumber": "{description} no es un número",
    "notAnInteger": "{description} debe ser un numero entero",
    "odd": "{description} debe ser número impar",
    "onOrAfter": "{description} debe estar en o después de {onOrAfter}",
    "onOrBefore": "{description} debe estar en o antes de {onOrBefore}",
    "otherThan": "{description} Debe ser otra cosa que {value}",
    "phone": "{description} debe ser un número de teléfono válido",
    "positive": "{description} debe ser un número positivo",
    "present": "{description} debe estar en blanco",
    "reportMissingAcademicYear": "Año Academico es Necesario",
    "reportMissingCompetency": "Competencia es Necesario",
    "reportMissingInstructor": "Instructor es Necesario",
    "reportMissingInstructorGroup": "Grupo de Instructor es Necesario",
    "reportMissingMeshTerm": "Término de MeSH es Necesario",
    "reportMissingObjectForCompetency": "Asociación es Necesario Cuando Competencia es el Sujeto",
    "reportMissingObjectForInstructor": "Asociación es Necesario Cuando Instructor es el Sujeto",
    "reportMissingObjectForInstructorGroup": "Asociación es Necesario Cuando Grupo de Instructor es el Sujeto",
    "reportMissingObjectForMeshTerm": "Asociación es Necesario Cuando Término de MeSH es el Sujeto",
    "reportMissingObjectForProgram": "Asociación es Necesario Cuando Programs es el Sujecto",
    "reportMissingObjectForSessionType": "Asociación es Necesario Cuando Tipo de Sesión es el Sujeto",
    "reportMissingObjectForTerm": "Asociación es Necesario Cuando Término es el Sujeto",
    "reportMissingProgram": "Programa es Necesario",
    "reportMissingProgramYear": "Año Programa es Necesario",
    "reportMissingSessionType": "Tipo de Sesión es Necesario",
    "reportMissingTerm": "Término es Necesario",
    "required": "{description} se requiere",
    "singular": "{description} no se puede ser una colección",
    "tooLong": "{description} es demasiado largo (el máximo es {max} caracteres)",
    "tooShort": "{description} es demasiado corto (el mínimo es {min} caracteres)",
    "url": "{description} debe ser una dirección URL válida",
    "wrongDateFormat": "{description} necesita ser en el formato de {format}",
    "wrongLength": "{description} es la longitud incorrecta (debe ser {is} caracteres)"
  },
  "general": {
    "aamcMethod": "Método de AAMC",
    "aamcPcrs": "AAMC PCRS",
    "aamcSchoolId": "Identificación de la escuela AAMC (\"ID de la institución\")",
    "academicLevel": "Nivel Académico",
    "academicLevels": "Niveles Académicos",
    "academicYear": "Año Academico",
    "academicYears": "Años Academicos",
    "accessAllMaterialsForThisCourse": "Acceso Todos los Materiales para este Curso",
    "accommodationIsRequiredForLearnersInSubgroups": "Se requiere alojamiento para los estudiantes de los siguientes subgrupos: {groups}",
    "accommodationIsRequiredForLearnersInThisGroup": "Se requiere alojamiento para los estudiantes de este grupo",
    "accountEnabled": "Cuenta Activa",
    "actions": "Acciones",
    "activate": "Activar",
    "active": "Activo",
    "activeFilters": "Filtros Activos",
    "add": "Agregue",
    "addCohort": "Agregar Cohorte",
    "addNew": "Agregue Nuevo",
    "admin": "Admin",
    "administrator": "Administrador",
    "administratorCount": "Hay {count, plural, =1 {1 administrador} other {# administradores}}",
    "administratorEmail": "Correo Eelectrónico del Administrador",
    "administratorEmailPlaceholder": "email@example.edu",
    "administratorEmails": "Correos Eelectrónicos del Administrador",
    "administrators": "Administradores",
    "advancedOptions": "Opciones Avanzadas",
    "all": "Todos",
    "allAcademicYears": "Todos Los Años Académicos",
    "allCourses": "Todos Los Cursos",
    "allEvents": "Todos los Eventos",
    "allMaterials": "Todos los Materiales",
    "allOtherMembers": "Todos otros miembros de {topLevelGroupTitle}",
    "allSchools": "Todas las Escuelas",
    "allVocabularies": "Todos los Vocabularios",
    "allWeeks": "Todas las Semanas",
    "anything": "Caulquier Cosa",
    "apiVersionMismatch": "Incompatibilidad de versión de API",
    "apiVersionMismatchDetails": "Por lo general, se trata de un error temporal de su navegador; Ilios está en modo de solo lectura hasta que se resuelva. Si la actualización no soluciona el problema, notifique a un administrador o al propietario técnico del sistema sobre este error. También puede probar con otro navegador.",
    "assessment": "Evaluación",
    "assessmentMethods": "Métodos de Evaluación",
    "assessmentOption": "Opción de Evaluación",
    "assessments": "Evaluacións",
    "assignedTerms": "Términos asignados",
    "associatedCourses": "Cursos Asociados",
    "associatedGroups": "Grupos Associados",
    "associatedWith": "Ssociado con",
    "attendanceIsRequired": "Se require asistencia",
    "attendanceIs_Required_": "Se '<strong><em>'require'</em></strong>' asistencia",
    "attendanceRequired": "Asistencia Requerida",
    "attribute": "Atributo",
    "author": "Autor",
    "autoUpdatingSeconds": "{count, plural, =1 {Actualización automática en 1 segundo...} other {Actualización automática en # segundos...}}",
    "available": "Disponible",
    "availableCohorts": "Clases de La Graduación Disponibles",
    "availableInstructors": "Instructores Disponibles",
    "availableInstructorsAndInstructorGroups": "Instructores y Grupos de instructores Disponibles",
    "availableLearnerGroups": "Grupos de Aprendedores Disponibles",
    "availableLearners": "Aprendedores Disponibles",
    "averageHoursOfInstructionPerWeek": "Promedio de horas de instrucción por semana",
    "back": "Volver",
    "backToAdminDashboard": "Atrás a Panel de Control",
    "backToCalendar": "Atrás a Calendario",
    "backToCourse": "Volver al Curso",
    "backToCourses": "Atrás a la Lista de Cursos",
    "backToDashboard": "Detrás a Tablero",
    "backToDetails": "Atrás a Las Detalles de la Sesión",
    "backToInstructorGroups": "Atrás a la Lista de Grupos de Instructores",
    "backToProgramYear": "Atrás a Año de Programa",
    "backToProgramYears": "Atrás a Años de Programas",
    "backToPrograms": "Atrás a Programas",
    "backToReport": "Atrás a Reporte",
    "backToReports": "Atrás a Reportes",
    "backToSchools": "Atrás a Escuelas",
    "backToSessionList": "Atrás a La Lista de Sesiones",
    "backToTableOfContents": "Atrás a la tabla de contenido",
    "backToTitle": "Atrás a {title}",
    "bad": "Malo",
    "badCredentials": "Incorrecta contraseña o nombre de usuario",
    "beforeOrAfterMidday": "Antes o después del mediodía",
    "bottomPagination": "Paginación inferior",
    "calendar": "Calendario",
    "calendarOff": "Calendario Apagado",
    "calendarOn": "Calendario en Uso",
    "campusId": "Campus ID",
    "campusNameOfRecord": "Nombre de registro del registrador",
    "canNotContinueWithInvalidRecords": "No se puede continuar con estos registros no válidos, por favor, corrija y vuelva a subir el archivo.",
    "canNotDeleteLearnerGroupWithAssociatedCourses": "Este grupo está unido a {courseCount, plural, one {un curso} other {# cursos}} y no se puede eliminar.",
    "cancel": "Cancelar",
    "changeAlertRecipients": "Destinatarios con alerta de cambio",
    "changeAlertRecipientsPlaceholder": "email1@example.edu, email2@example.edu",
    "childSequenceOrder": "Orden de Secuencia de Los Hijos",
    "chooseCohortTitle": "Seleccione Matriz Para",
    "chooseFile": "Seleccione Archivo",
    "citation": "Citación",
    "city": "Ciudad",
    "classOf": "Clase de {year}",
    "clearDates": "Borrar Fechas",
    "clearErrors": "Borrar los Errores y Volver a Ilios",
    "clearFilters": "Borrar Filtros",
    "clerkship": "Rotación",
    "clerkshipSequenceBlocks": "Bloques de secuencia de rotación",
    "clerkshipType": "Tipo de Rotación",
    "clickForMore": "Haga clic para más información",
    "clickToAddDescription": "Haga clic para añadir una descripción",
    "clickToAddTermDescription": "Haga clic para agregar notas descriptivas",
    "clickToEdit": "Hacer clic para editar",
    "close": "Cerrar",
    "cohort": "Clase de la Graduación",
    "cohortMembersNotInGroup": "Miembros de la Clase NO Asignados a {groupTitle} ",
    "cohorts": "Clases de la Graduación",
    "cohortsManageTitle": "Administrar Clases de La Graduación",
    "collapse": "colapsar",
    "collapseDetail": "Esconder Detalles",
    "color": "Color",
    "competencies": "Competencias",
    "competenciesManageTitle": "Maneje Competencias",
    "competency": "Competencia",
    "competencyDomain": "Dominio de Dompetencia",
    "complete": "Completo",
    "completeSessions": "Sesiónes Completas: Listo a Publicar",
    "confirmLogout": "Usted ha cerrado la aplicación Ilios con éxito. Para asistir con la protección de su cuenta y la seguridad de otros, favor de cerrar todas las ventanas del navegador.",
    "confirmObjectiveRemoval": "¿Está seguro que desea eliminar este objetivo?",
    "confirmObjectiveRemovalMultipleSessionObjectives": "Está a punto de eliminar este objetivo de curso, que está vinculado a {count} objetivos de sesión. Esto eliminará también esas relaciones. ¿Está seguro que desea continuar?",
    "confirmRemoval": "¿Está seguro que desea eliminar este material de aprendizaje?",
    "confirmRemove": "¿Estás seguro que quieres borrar este ofrecimiento con {learnerGroupCount} grupos de aprendedores? Esta acción no se puede deshacer.",
    "confirmRemoveCourse": " ¿Estás seguro que quieres borrar este curso, con {publishedOfferingCount} ofrecimientos publicados? Esta acción borrará todas las sesiones y ofrecimientos para este curso y no se puede deshacer.",
    "confirmRemoveInstructorGroup": "¿Estás seguro que quieres remover este grupo de instructores, con {instructorCount} instructores? Esta acción no se puede deshacer.",
    "confirmRemoveLearnerGroup": "¿Estás seguro que quieres borrar este grupo de aprendedores, con {subgroupCount} grupos subordinados? Esta acción no se puede deshacer.",
    "confirmRemoveProgram": "¿Estás seguro que quieres borrar este programa? Esta accion no se puede deshacer.",
    "confirmRemoveProgramYear": "¿Está seguro de que desea eliminar este año del programa?   Hacer tan también quitará su cohorte estudiantil asociada y grupos y asociaciones con {courseCount} curso(s), y no se puede deshacer.",
    "confirmSessionRemoval": "¿Está seguro que desea eliminar este sessión?",
    "confirmVocabularyRemoval": "¿Está seguro que desea eliminar este vocabulario?",
    "connectionLost": "Conexión Perdida.",
    "contentAuthor": "Autor del Contenido",
    "continue": "Continuar",
    "copiedIcsFeedUrl": "Copiado Mi Enlace ICS con Éxito",
    "copiedSuccessfully": "Copiado con Éxito",
    "copy": "Copiar",
    "copyIcsFeedUrl": "Copiar Mi Enlace ICS",
    "copyLink": "Copiar el enlace",
    "copyNewToken": "Copiar nuevo token",
    "copySession": "Copiar una Sesión",
    "copySessionSummary": "Usted va a copiar esta sesión (sin datos del horario) en el curso seleccionado. La sesión nueva va a incluir todos los objectivos, terminos, y materiales de aprendizaje.  Para continuar haga click en \"cumplido\".  Para regresar a su sesión corriente, haga click en \"cancelar\".",
    "copySuccess": "La Copia se ha Completado con Éxito",
    "copyWithLearners": "Copiar Con Alumnos",
    "copyWithoutLearners": "Copiar Sin Alumnos",
    "copyrightAgreement": "El archivo que estoy subiendo es mío o tengo permiso expreso para reproducir y / o distribuir este artículo, o su uso aquí ha sido evaluado como permisible por la doctrina del uso justo. Este archivo no contiene ninguna información protegida de la salud, y su utilización aquí está en conformidad con las políticas del gobierno y Universidad sobre derechos de autor y de seguridad de la información y las directrices de mi institución para la conducta profesional.",
    "copyrightPermission": "Permisos de Derechos de Autor",
    "copyrightRationale": "Justificación para Derechos de Autor",
    "couldNotFindUserCampusId": "No se pudo encontrar un usuario con el campusId {campusId}",
    "countAsOneOffering": "Cuenta como un Ofrecimiento",
    "countTotal": "{total} en total",
    "country": "País",
    "course": "Curso",
    "courseDirector": "Director del Curso",
    "courseLearningMaterials": "Materiales de Aprendizaje del Curso",
    "courseLevel": "Nivel del curso {level}",
    "courseLevels": "Niveles de Curso",
    "courseMaterials": "Materiales del Curso",
    "courseNotFound": "curso no encontrado",
    "courseObjective": "Objetivo del Curso",
    "courseObjectives": "Objetivos del Curso",
    "courseOrSessionType": "Curso / Tipo de Sesión",
    "courseRollover": "Copiar Curso",
    "courseRolloverSuccess": "Curso Copiado con Éxito",
    "courseRolloverSummary": "Va a rodar este curso en el seleccionado año académico, junto con todas las opciones seleccionadas.. Para continuar, haga clic en \"done\". Para volver a su curso corriente, haga clic en \"cancel\"",
    "courseRolloverYearUnavailable": "El Curso Ya Existe",
    "courseTitle": "Titulo de Curso",
    "courseTitleFilterPlaceholder": "Aplicar un filtro por título de curso",
    "courseTitlePlaceholder": "Entre en un título para este curso",
    "courseVisualizations": "Visualizaciones de Cursos",
    "courseVisualizationsInstructorNoData": "{instructor} no está impartiendo ninguna sesión en este curso.",
    "courseVisualizationsInstructorsGraphNoData": "No se han vinculado instructores a ninguna sesión de este curso.",
    "courseVisualizationsNoSessions": "Este curso no tiene sesiones.",
    "courseVisualizationsSessionTypeGraphNoData": "No se han vinculado términos de vocabulario a ninguna sesión {sessionType} en este curso.",
    "courseVisualizationsTermGraphNoData": "El término de vocabulario {term} no se ha vinculado a ninguna sesión de este curso.",
    "courseVisualizationsVocabularyGraphNoData": "No se han vinculado términos del vocabulario {vocabulary} a ninguna sesión de este curso.",
    "courses": "Cursos",
    "coursesAndSessions": "Cursos y Sesiones",
    "create": "Crear Nuevo Usuario",
    "createBulk": "Subir Múltiples Usuarios.",
    "createNew": "Crear Nuevo",
    "createNewGroup": "Crear Este Grupo",
    "currentCompetency": "Competencia Actual",
    "currentSchool": "Escuela Actual",
    "currentlySearchingPrompt": "buscando...",
    "curriculumInventory": "Inventario de plan de Estudios",
    "curriculumInventoryInstitutionalInfo": "Inventario de plan de Estudios Información Institucional",
    "curriculumInventoryReport": "Informe de Inventario de Plan de Estudios",
    "curriculumInventoryReportRollover": "Copiar Inventario de plan de Estudios",
    "curriculumInventoryReportRolloverSuccess": "Inventario Copiado con Éxito",
    "curriculumInventoryReportRolloverSummary": "Esta acción copiará la estructura de este informe que se utilizará en su año objetivo. No copiará la información del curso, solo la estructura del bloque de secuencia de nivel superior. Deberá agregar la información del curso adecuada y modificar las fechas de inicio y finalización del bloque de secuencia una vez que haya cambiado la estructura del informe existente.",
    "curriculumInventoryReports": "Informes de Inventario de Plan de Estudios",
    "dashboard": "Tablero",
    "dashboardNavigation": "Panel de navegación",
    "date": "Fecha",
    "dateTime": "Fecha/Hora",
    "day": "Día",
    "deactivate": "Desactivar",
    "defaultInstructors": "Instructores Predeterminados",
    "defaultInstructorsNotLoaded": "(Instructores predeterminados no se cargarán: por favor introduzca el valor deseado.)",
    "defaultLocation": "Ubicación Predeterminada",
    "defaultLocationNotLoaded": "(Ubicación predterminada no se cargará: por favor introduzca el valor deseado.)",
    "defaultNotLoaded": "Predeterminado no cargado",
    "defaultVirtualLearningLink": "Enlace de Aprendizaje Virtual Predeterminado",
    "delete": "Eliminar",
    "deleteCourse": "Eliminar el curso",
    "departments": "Departmentos",
    "deprecatedAbbreviation": "obs.",
    "description": "Descripción",
    "deselectUser": "Deseleccione usuario",
    "details": "Detalles de Curso",
    "developer": "Desarrollador",
    "director": "Director",
    "directorCount": "Hay {count, plural, =1 {1 director} other {# directores}}",
    "directors": "Directores",
    "disableUser": "Desactivar el usuario",
    "disabled": "desactivado",
    "displayName": "Nombre de Mostrar",
    "doesNotMatchUserRecord": "Cargado {description} no coincide con la información en Ilios, cuál es \"{record}\"",
    "domain": "Dominio",
    "done": "Acabado",
    "download": "Descargar",
    "downloadCompetencyMap": "Descargar el mapa de competencias",
    "downloadResults": "Descargar Resultados",
    "draft": "Borrador",
    "dueBefore": "Debido antes de",
    "dueBy": "Debido Por",
    "duePriorTo": "Debido antes de",
    "duration": "Duración",
    "durationHours": "{count, plural, =1 {un hora} other {# horas}}",
    "durationInDays": "Duración (en Días)",
    "durationInYears": "Duración (en Años)",
    "durationMinutes": "{count, plural, =1 {1 minudo} other {# minudos}}",
    "edit": "Editar",
    "educationalYear": "Año Escolar",
    "email": "Correo",
    "emails": "Correos",
    "enabled": "Activa",
    "end": "Termino",
    "endDate": "Fecha de Cumplir",
    "endLevel": "nivel final",
    "endTime": "Hora de Cumplir",
    "ends": "Termina",
    "error": "Error",
    "errorDisplayMessage": "Lo sentimos! Algo salió mal con su pedido. Por favor, trate de actualizar la página o revise de nuevo más tarde.",
    "errorSavingAuthentication": "Las cuentas fueron creadas para estos usuarios, pero no podrán iniciar sesión.  Esto generalmente sucede cuando el nombre de usuario ya existe, pero pertenece a otro usuario.  Por favor seleccione cada usuario y crear un nombre de usuario y contraseña.",
    "errorSavingUser": "Estos usuarios fueron incapaces de salvarse. Por favor, compruebe que no existen.",
    "errors": "Errores",
    "etAl": "et al.",
    "eventNotFoundExplanation": "El evento al que ha intentado acceder ya no está disponible o ha seguido un enlace de usuario personalizado que no se puede compartir. Si sigue teniendo problemas, póngase en contacto con el servicio de asistencia de Ilios.",
    "eventNotFoundTitle": "Evento no encontrado",
    "exclude": "Excluir",
    "excludeFromSync": "Excluir de la sincronización",
    "existingGroup": "Grupo Existente",
    "expand": "expandir",
    "expandDetail": "Enseñar Detalles",
    "externalId": "Identificación del Curso",
    "file": "Archivo",
    "file-audio": "Archivo de audio",
    "file-pdf": "Archivo PDF",
    "file-powerpoint": "Archivo de PowerPoint",
    "file-video": "Archivo de vídeo",
    "fileSizeError": "Este archivo es demasiado grande.  El tamaño máximo es {maxSize}.",
    "fileTypeError": "Archivo mal subido: {fileType} no parece ser válido ficha separado archivo.",
    "fileUploadError": "No pudimos subir este archivo.   Por favor, asegúrese de que está conectado a la red.  Si este problema persiste, por favor avísenos.",
    "filterByNameOrEmail": "Aplicar un Filtro por nombre o email",
    "filterByProgram": "Filtrar por Programa",
    "filterBySchool": "Filtrar por Escuela",
    "filterByTitle": "Filtrar por Título",
    "filterByYear": "Filtrar por Año",
    "filterChartPlaceholder": "Empieza marcando para filtrar este gráfico",
    "filterPlaceholder": "Empieza marcando para aplicar un filtro",
    "finalErrorDisplayMessage": "¡Zoinks! Algo es muy incorrecto. Por favor refresque su navegador y avísenos en support@iliosproject.org si sigue viendo este mensaje. ",
    "finalResults": "Resultados Finales",
    "finalize": "Finalizar",
    "finalizeReportConfirmation": "Finalizando este informe, lo salvará en su estado actual a la base de datos de Ilios como un objeto de la referencia permanente, y ninguna otra edición será posible.",
    "finalized": "Finalizado",
    "finalizingReport": "Finalizando informe, esto puede tardar un tiempo ...",
    "findDirector": "Buscar Director",
    "findInstructorOrGroup": "Buscar Instructor o Grupo",
    "findLearners": "Encontrar estudiantes",
    "first": "Primero",
    "firstName": "Nombre",
    "firstOffering": "Ofrecimiento Primero",
    "for": "Para",
    "formative": "formativa",
    "formerStudent": "Antiguo Estudiante",
    "forward": "Adelante",
    "friday": "Viernes",
    "fullName": "Nombre completo",
    "globalSearchPlaceholder": "Encontrar Usuarios...",
    "go": "Vaya",
    "goToNextYear": "Ir al año que viene",
    "goToPreviousYear": "Ir al año anterior",
    "goToUser": "Mostrar registro de usuario en Ilios",
    "good": "Bueno",
    "groupByCompetencies": "Agrupe por Competencias",
    "groupMembers": "Miembros de grupo corriente",
    "groupName": "Nombre De Grupo",
    "groups": "Grupos",
    "hideCalendar": "Esconda Calendario",
    "hideCourseMaterials": "Ocultar materiales del curso",
    "hideFilters": "Esconde Filtros",
    "hideIcsFeed": "Ocultar Opciones de Fuente de Datos ICS",
    "hideObjectives": "Ocultar objetivos",
    "hideRolesInCourses": "Ocultar roles en cursos",
    "hideRolesInProgramYears": "Ocultar roles en los años del programa",
    "hideRolesInPrograms": "Ocultar roles en programas",
    "hideRolesInSessions": "Ocultar roles en sesiones",
    "hideSessionMaterials": "Ocultar materiales de sesión",
    "home": "Inicio",
    "hour": "Hora",
    "hours": "Horas",
    "icsAdminInstructions": "Para agregar el calendario de Ilios de un usuario a otra aplicación o servicio, será necesario utilizar esta URL.  esta dirección URL es como una contraseña. ¡Quien lo sabe puede ver el calendario de este usuario!",
    "icsFeed": "Fuente de ICS",
    "icsInstructions": "Para agregar tu calendario a otra aplicación o servicio, utiliza esta URL.  Esta URL es como una contraseña.  ¡Cualquiera persona que la sepa puede ver tu calendario!",
    "id": "ID",
    "ignore": "Ignorar",
    "ilios": "Ilios",
    "iliosUpdatePending": "¡Huzzah, hemos hecho Ilios mejor! Obtendrá las cosas nuevas en su próximo inicio de sesión, o haga clic para actualizar ahora.",
    "iliosUserGuide": "Ilios Guía de usuario",
    "ilm": "ILM",
    "ilmDue": "AI - Debido Por",
    "in": "en",
    "inProgress": "En Progreso",
    "inactive": "inactivo",
    "include": "Incluir",
    "includedInGrade": "Incluido en Grado",
    "incompleteSessions": "Sesiónes Incompletas: No se pueden publicar",
    "independentLearning": "Aprendizaje Independiente",
    "independentLearningActivities": "Aprendizaje Independiente Actividades",
    "instructing": "Instruyendo",
    "instructionalMethod": "Método de Instrucción",
    "instructionalMethods": "Métodos de Instrucción",
    "instructionalNotes": "Notes para la Instrucción",
    "instructor": "Instructor",
    "instructorGroup": "Grupo de Instructores",
    "instructorGroupMembers": "Miembros del grupo instructor",
    "instructorGroupTitle": "Titulo de Grupo de Instructores",
    "instructorGroupTitleFilterPlaceholder": "Aplicar un Filtro por Título de Grupo de Instructor",
    "instructorGroupTitlePlaceholder": "Entre en un Título para este grupo de Instructores",
    "instructorGroups": "Grupos de Instructores",
    "instructors": "Instructores",
    "instructorsAndInstructorGroups": "Instructores y Grupos de Instructores",
    "instructorsAndInstructorGroupsWithCount": "Instructores ({instructorCount}) y Grupos de Instructores ({instructorGroupCount})",
    "instructorsManageTitle": "Administrar Instructores",
    "invalidDatetimes": "Fecha/Hora Inválida",
    "invalidUsers": "Usuarios no Válidos",
    "invalidateTokens": "Invalida Todos los Tokens",
    "invalidateTokensConfirmation": "Esto invalidará todas los tokens de API existentes y ustedes tendrán que generar nuevos tokens para cualquier aplicación que tengan. ¿Está seguro que desea hacer esto?",
    "isSelective": "Es selectivo",
    "isTrack": "Es la Pista",
    "itemCode": "Código de artículo",
    "language": {
      "en-us": "English (en)",
      "es": "Español (es)",
      "fr": "Français (fr)"
    },
    "last": "Último",
    "lastName": "Apellido",
    "lastUpdate": "Última actualización",
    "leadership": "Liderazgo",
    "learner": "Aprendedor",
    "learnerAssignments": "{groupTitle} Asignaciónes de Aprendedores",
    "learnerGroupTitle": "Título de Grupo de Instructores",
    "learnerGroupTitleFilterPlaceholder": "Aplicar un Filtro por Título de Grupo de Aprendedor",
    "learnerGroupTitlePlaceholder": "Entre en un Título para este grupo de aprendedores",
    "learnerGroups": "Grupos de Aprendedores",
    "learnerGroupsManageTitle": "Administrar Grupos de Aprendedores",
    "learners": "Aprendedores",
    "learnersAndLearnerGroups": "Aprendedores y Grupos de Aprendedores",
    "learnersAndLearnerGroupsWithCount": "Aprendedores ({learnerCount}) y Grupos de Aprendedores ({learnerGroupCount})",
    "learning": "Aprendiendo",
    "learningMaterial": "Material de Aprendizaje",
    "learningMaterialManageTitle": "Administrar Materiales de Aprendizaje",
    "learningMaterials": "Materiales de Aprendizaje",
    "learningMaterialsSummary": "Resumen de Materiales de Aprendizaje",
    "level": "Nivel",
    "link": "Enlace de la Web",
    "linkedCompetencies": "Competencias Vinculadas",
    "linkedCompetencyCount": "{count, plural, =1 {1 tiene una competencia vinculada} other {# tienen competencias vinculadas}}",
    "listByPriority": "Lista por prioridad",
    "lmDescriptorTitle": "Seleccione Descriptores de MeSH para Materiales de Aprendizaje",
    "loading": "Marcando Ilios",
    "loadingEvents": "Cargando eventos...",
    "loadingMaterials": "Carga de Materiales...",
    "loadingSessionTypes": "Cargando Tipos de Sesión...",
    "location": "Ubicación",
    "lockCourse": "Bloquear el curso",
    "login": "Inicio",
    "logo": "Logo de Ilios",
    "logout": "Cerrar aplicación",
    "makeRecurring": "Hacer Recurrente",
    "manage": "Manejar",
    "manageAPITokens": "Maneje Tokens de la API",
    "manageCompetencies": "Maneje Competencias",
    "manageDefaultInstructors": "Maneje instructores predeterminados",
    "manageEmails": "Administrar correos electrónicos",
    "manageGroupMembership": "Administrar membresía de grupo",
    "manageInstitutionalInfo": "Administrar información institucional del CIR",
    "manageLeadership": "Maneje el Liderazgo",
    "manageLearners": "Administrar Aprendedores",
    "manageSessionAttributes": "Maneje Atributos de la Sesión",
    "manageUsers": "Administrar Usuarios",
    "manageUsersSummaryTitle": "Usuarios de Ilios",
    "manageVocabularies": "Maneje Vocabularios",
    "markAsScheduled": "Marque Como Programado",
    "matchGroups": "Igualar Grupos",
    "materials": "Materiales",
    "matriculationYear": "Año de Inscripción",
    "maximum": "Máximo",
    "members": "Miembros",
    "menu": "El Menú de Ilios",
    "mesh": "MeSH",
    "meshCount": "{count, plural, =1 {1 tiene MeSH} other {# tienen MeSH}}",
    "meshManageTitle": "Administrar MeSH",
    "meshTerm": "Término de MeSH",
    "meshTerms": "Terminos de MeSH",
    "message": "Mensaje",
    "middleName": "Segundo Nombre",
    "minimum": "Mínimo",
    "minute": "Minuto",
    "minutes": "Minutos",
    "missingCohortMessage": "Favor de agregar por lo menos un Clase de La Graduación a este curso.",
    "missingCompetenciesMessage": "Favor de agregar por lo menos una competencia para este año de programa.",
    "missingCourseObjectivesMessage": "Favor de agregar por lo menos un objetivo al Curso.",
    "missingItems": "Artículos Faltantes",
    "missingPassword": "Contraseña requirida",
    "missingRequiredUsername": "'Nombre de Usuario' se requiere para la entrada al sistema; este usuario será incapaz a la entrada al sistema hasta que un username sea entrado",
    "missingUsername": "Nombre de usaurio requirido",
    "modifyUserPassword": "Haga clic aquí para restablecer la contraseña.",
    "monday": "Lunes",
    "month": "Mes",
    "moreInputRequiredPrompt": "sigue marcando...",
    "moveToGroup": "{count, plural, =1 {Mueva estudiante a {groupTitle}} other {Mueva # estudiantes a {groupTitle}}}",
    "multiDay": "Días Múltiples",
    "multiday": "de Días Múltiples",
    "multidayEvents": "Eventos de Varios Días",
    "multiple": "Múltiple ",
    "multipleGroups": "Múltiples grupos",
    "multipleUsersFoundWithCampusId": "Varios usuarios encontrados con el campusId {campusId}",
    "mustBeSameDayOfWeekAsCurrentStartDate": "Debe ser el mismo día de la semana en curso como fecha de inicio",
    "myCalendar": "Mi Calendario",
    "myCourses": "Mis Cursos",
    "myLearningMaterials": "Mis Materiales Didácticos",
    "myMaterials": "Mis Materiales",
    "myProfile": "Mi Perfil",
    "mySchedule": "Mi Horario",
    "name": "Nombre",
    "narrative": "narrativa",
    "navigation": "Navegación",
    "navigationCompleteText": "La navegación de la página de Ilios está completa. Ahora puede navegar por el contenido de la página como desee.",
    "newCourse": "Curso Nuevo",
    "newCurriculumInventoryReport": "Nuevo Informe de Inventario de Plan de Estudios",
    "newDomain": "Nuevo Dominio",
    "newInstructorGroup": "Nuevo Grupo de Instructores",
    "newLearnerGroup": "Nuevo Grupo de Aprendedores",
    "newObjective": "Nuevo Objetivo",
    "newObjectiveSaved": "Nuevo Objetivo Guardado",
    "newOffering": "Nueva Oferta",
    "newProgram": "Programa Nuevo",
    "newProgramYear": "Nuevo Año Del Programa",
    "newReport": "Nuevo Reporte",
    "newSchool": "Nueva Escuela",
    "newSequenceBlock": "Nuevo Bloque de Secuencia",
    "newSession": "Sesión Nueva",
    "newTerm": "Nuevo Termino",
    "newToken": "Nuevo Símbolo (Token)",
    "newUpdates": "Nuevas actualizaciones",
    "newUser": "Nuevo Usuario",
    "newUsersCreatedSuccessfully": "Nuevos usuarios creados con éxito",
    "newUsersCreatedWarning": "Algunos usuarios fueron creados, pero hubo errores.",
    "next": "Siguiente",
    "nextXDays": "Próximos {days} días",
    "no": "No",
    "noAccountExists": "Su cuenta {accountName} no coincide con los registros de Ilios. Si usted necesita más asistencia, póngase en contacto con su administrador de Ilios",
    "noAssociatedCompetencies": "No Competencias Asociadas",
    "noAssociatedCompetency": "No Competencia Asociada",
    "noAvailableCohorts": "Ningun Clase de La Graduación Disponible",
    "noAvailableLearnerGroups": "No grupo de aprendedores disponible; Este curso no contiene ninguna clase de la graduación.",
    "noAvailableLearners": "No aprendedores disponible; Este curso no contiene ninguna clase de la graduación.",
    "noCohorts": "No hay ningún clase de la graduación en este curso",
    "noCohortsAvailableForStudentAssignment": "No hay cohortes disponibles para la asignación de estudiantes en esta escuela.",
    "noCourseLearningMaterialsAvailable": "Ningunos Materiales Didácticos del Curso Disponibles",
    "noCourses": "No hay ningún curso en esta escuela",
    "noCurriculumInventoryInstitutionalInfo": "No se ha configurado información institucional para esta escuela.",
    "noEvents": "no eventos",
    "noLearnerGroups": "No Grupos de Aprendedores",
    "noOfferingLearnerGroups": "Ningunos Grupos",
    "noOfferings": "Esta sesión no tiene ningunos ofrecimientos",
    "noPermissionsInOtherSchools": "No tiene los permisos necesarios de añadir a este usuario a cualquier otra escuela.",
    "noPopulateGroup": "¡No! Déjelo vacío. Voy a agregar alumnos yo mismo.",
    "noPrintDraft": "Cursos que se encuentran en estado borrador no se puede imprimir",
    "noProgramYears": "No hay años de programa en este programa",
    "noResultsFound": "Ningún resultado encontrado. Por favor intente otra vez.",
    "noSearchResults": "Su búsqueda no regresó ningunos resultados",
    "noSearchResultsPrompt": "no resultados",
    "noSelectedCompetencies": "No hay competencias seleccionadas",
    "noSelectedLearnerGroups": "No hay grupos de aprendedores seleccionados",
    "noSequenceBlocks": "No hay bloques de secuencia en este informe.",
    "noSessionLearningMaterialsAvailable": "Ningunos Materiales Didácticos de la Sesión Disponibles",
    "noSessions": "No hay ningún sesión en este curso",
    "noSubSequenceBlocks": "Este bloque de la secuencia no tiene bloques de secuencia anidadas.",
    "noSubgroups": "No hay ningunos grupos subordinados en este grupo de aprendedores",
    "noUnselectedCompetencies": "No hay competencias disponibles para selección",
    "noUnselectedLearnerGroupsInCohort": "No hay grupos de aprendedores no seleccionados en este Clase de La Graduación",
    "nonClerkshipSequenceBlocks": "Bloques de secuencia que no son de la rotación",
    "nonStudent": "No estudiante",
    "none": "Ningún",
    "notAClerkship": "No una Rotación",
    "notApplicableAbbr": "n/d",
    "notFoundMessage": "Malditas! Éso no puede encontrar. Favor de verificar la dirección de la página, y trata otra vez.",
    "notPublished": "No Publicado",
    "notStarted": "No Comenzado",
    "notes": "Notas",
    "numberOfEvents": "Numero de eventos",
    "numberOfEventsFeaturingThisAsThePrimaryMethod": "Número de eventos con esto como método principal",
    "numberOfExams": "Numero de Exámenes",
    "numberOfFormalInstructionalHoursPerCourse": "Número de horas formales de instrucción por curso",
    "numberOfFormativeAssessments": "Número de evaluaciones formativas",
    "numberOfGroups": "Número de grupos",
    "numberOfGroupsToGenerate": "número de grupos para generar.",
    "numberOfNonPrimaryOccurrencesOfThisMethod": "Número de ocurrencias no primarias de este método",
    "numberOfSummativeAssessments": "Número de evaluaciones sumativas",
    "objective": "Objetivo",
    "objectiveCompetencyManagerTitle": "Seleccione Competencia Principal para Objetivo",
    "objectiveCount": "Hay {count, plural, =1 {1 objectivo} other {# objectivos}}",
    "objectiveDescriptorTitle": "Seleccione Descriptores de MeSH para Objetivo",
    "objectiveMap": "Mapa de Objetivos",
    "objectiveParentTitle": "Seleccione Objetivos Principales",
    "objectiveParentTitleSingular": "Seleccione Objetivo Principale",
    "objectiveParentsTitle": "Seleccione Objetivos Matrices",
    "objectiveTitle": "Objetivos de la Sesión",
    "objectives": "Objetivos",
    "objectivesWithNoHours": "Los siguientes objetivos del curso no están vinculados a ninguna sesión, o están vinculados sólo a las sesiones sin datos de duración.",
    "objectivesWithNoLink": "No hay objetivos del curso actualmente vinculados a tiempo de instrucción.",
    "off": "Apagado",
    "offering": "Ofrecimiento",
    "offerings": "Ofrecimientos",
    "ok": "OK",
    "on": "Encendido",
    "openSmallGroupGenerator": "Abrir el Generador de Ofrecimientos para Grupos Pequeños",
    "optional": "Opcional",
    "optionalElective": "Opcional (electiva)",
    "orderInSequence": "Orden en la Secuencia",
    "ordered": "Ordenado",
    "other": "Otro",
    "otherId": "Otro ID",
    "otherVisualizations": "Otras Visualizaciones",
    "overview": "Visión Amplia",
    "ownedBy": "propiedad de {owner}",
    "owner": "Dueño",
    "pagedResultsCount": "Mostrando {start} - {end} de {total}",
    "parallel": "Paralelo",
    "parentCount": "{count, plural, =1 {1 tiene un Principal objectivo} other {# tienen Objectivos Principales}}",
    "parentGroup": "Principal grupo",
    "parentGroups": "Grupos principales",
    "parentObjectives": "Objetivos de Matriz",
    "password": "Contraseña",
    "pendingUpdatesSummary": "{count, plural, =1 {Hay un usuario que necesita atención} other {Hay # usuarios que necesitan atención}}",
    "pendingUpdatesSummaryTitle": "Actualizaciones del Directorio del Campus",
    "pendingUserUpdates": {
      "emailMismatch": "La dirección de correo electrónico en el directorio ({value}) does not match the email in Ilios ({email}).",
      "filterBy": "Filtro por nombre de uauario",
      "missingFromDirectory": "No se puede encontrar el usuario en el directorio, por favor actualice, desactive, o excluya su cuenta de la sincronización.",
      "updateIlios": "Actualice Ilios"
    },
    "people": "Gente",
    "perPage": "Por Página",
    "percentage": "Porcentaje",
    "performsNonLearnerFunctions": "Performe Funciones de Non-Aprendedor",
    "permissions": "Permisos",
    "permissionsInOtherSchools": "Permisos en Otras Escuelas",
    "phasesStartToEnd": "Fases (inicio - final)",
    "phone": "Teléfono",
    "physicianCompetencyReferenceSet": "Conjunto de referencia de competencias médicas",
    "physicianCompetencyReferenceSetAbbr": "PCRS",
    "pickADate": "Elija una fecha",
    "populateGroup": "¿Quieres auto-llenar este grupo?",
    "preWork": "Pre Trabajo",
    "preferredEmail": "Email preferido",
    "prerequisites": "Prerrequisitos",
    "prev": "Anterior",
    "previous": "Anterior",
    "primary": "Principal",
    "primaryCohort": "Clase de la Graduación Principal",
    "primarySchool": "Escuela Primaria",
    "printSummary": "Sumario Printado",
    "program": "Programa",
    "programAndCohort": "Programa / Clase de La Graduación",
    "programCohorts": "Clases de La Graduación",
    "programDetail": "Detalle del programa",
    "programExpectations": "Expectativas del programa",
    "programExpectationsId": "ID de expectativas del programa",
    "programLeadership": "Liderazgo del Programa",
    "programTitle": "Titulo de Programa",
    "programTitleFilterPlaceholder": "Filtrar por Titulo de Programa",
    "programTitlePlaceholder": "Meter un titulo para este programa",
    "programTitleShort": "Titulo (corto)",
    "programYear": "Año de Programa",
    "programYearLeadership": "Liderazgo de Año de Programa",
    "programYearVisualizations": "Visualizaciones de Año de Programa",
    "programYears": "Años de Programa",
    "programs": "Programas",
    "promoteToPrimaryCohort": "Ascender al Principal Cohorte",
    "pronouns": "Pronombres",
    "publicationStatus": "Estado de Publicación",
    "publishAllConfirmation": "Publique {publishCount}, Programe {scheduleCount}, y ignore {ignoreCount} sesiónes",
    "publishAllSessions": "Publique {sessionCount} sesiónes",
    "publishAsIs": "Publique Como Es",
    "publishCourse": "Publique Curso",
    "publishProgram": "Publique El Programa",
    "publishProgramYear": "Publique Año de Programa",
    "publishSession": "Publique La Sesión",
    "published": "Publicado",
    "publishedSuccessfully": "Publicado con Éxito",
    "read": "Leer",
    "reconnectNow": "Volver a conectar ahora",
    "reconnectionSeconds": "{count, plural, =1 {Reconectando en 1 segundo...} other {Reconectando en # segundos...}}",
    "refreshIcsFeedKey": "Refresque la llave de la Fuente de ICS para este usuario.",
    "refreshTheBrowser": "Refresque el Navegador",
    "remove": "Remover",
    "removeAll": "Quitar Todos",
    "removeCohort": "Remover Cohorte",
    "removeLearnerToCohort": "{count, plural, =1 {Quite estudiante a {cohort}} other {Quite # estudiantes a {cohort}}}",
    "removePrimaryCohort": "Remover Principal Cohorte",
    "removedSuccessfully": "Eliminado con éxito",
    "reportConfirmRemove": "¿Está seguro que desea eliminar este informe? Esta acción no se puede deshacer.",
    "reportDescriptionPlaceholder": "Por favor entre en una breve descripción sobre este informe.",
    "reportDisplayDescriptionWithObject": "Este informe muestra todos los {subject} asociados con {objectType} \"{object}\" {year} en {school}.",
    "reportDisplayDescriptionWithoutObject": "Este informe muestra todos los {subject} en {school}.",
    "reportDisplayTitleWithObject": "Todos {subject} para {object} en {school}",
    "reportDisplayTitleWithoutObject": "Todos {subject} en {school}",
    "reportName": "Nombre de Informe",
    "reportNamePlaceholder": "Por favor Introduzca un Nombre de Informe",
    "reportTitle": "Título de Informe",
    "reports": "Informes",
    "required": "Requerido",
    "requiredInTrack": "Requerido en Pista",
    "resourceTypes": "Tipos de recursos",
    "results": "Resultados",
    "resultsCount": "{count, plural, =1 {1 resultado} other {# resultados}}",
    "returnToPreviousPage": "Volver a la Página Anterior",
    "reviewMissingItems": "Revisar {count} Artículos Faltantes",
    "reviewSessions": "Sesiónes a Revisar",
    "root": "Root",
    "runReport": "Ejecutar Informe",
    "sampleFile": "Archivo de Ejemplo",
    "saturday": "Sábado",
    "save": "Guardar",
    "saved": "Nuevo Usuario Salvó con Éxito",
    "savedSuccessfully": "Ahorrado Con Éxito",
    "scheduled": "Programado",
    "scheduledSuccessfully": "Programdo con Éxito",
    "scheduling": "Programación",
    "school": "Escuela",
    "schoolName": "Nombre de escuela",
    "schools": "Escuelas",
    "search": "Buscar",
    "searchDirectory": "Busque el directorio para nuevos usuarios",
    "searchForIliosUsers": "Encuentre Usuarios de Ilios...",
    "searchMesh": "Buscar MeSH",
    "searchPlaceholder": "encontrar material de aprendizaje",
    "searchTheCurriculum": "Buscar el plan de estudios ",
    "searchUsers": "Buscar usuarios",
    "secondaryCohorts": "Clases de la Graduación Secondarias",
    "select": "Selecciona",
    "selectAcademicYear": "Selecciona Año Academico",
    "selectAllOrNone": "Seleccione Todo o Ninguno",
    "selectCohortsToAttach": "Seleccione la cohorte de estudiantes que desea adjuntar al nuevo curso",
    "selectCourse": "Seleccionar un curso",
    "selectMeshFor": "Seleccione MeSH para: {title}",
    "selectPolite": "(seleccione uno, por favor)",
    "selectProgram": "Seleccione un Programa",
    "selectSchool": "Seleccione Escuela",
    "selectUser": "Seleccione usuario",
    "selectVocabulary": "Seleccione un Vocabulario",
    "selectYear": "Seleccione El Año Escolar",
    "selected": "Escogido",
    "selectedInstructorGroups": "Grupos de Instructores Seleccionados",
    "selectedInstructors": "Instructores Seleccionados",
    "selectedLearnerGroups": "Grupos de Aprendizaje Seleccionados",
    "selectedLearners": "Aprendizaje Seleccionados",
    "sequenceBlock": "Bloque de Secuencia",
    "sequenceBlockConfirmRemove": "¿Está seguro que desea eliminar este bloque de secuencia? Esta acción no se puede deshacer.",
    "sequenceBlockDescriptionPlaceholder": "Por favor, introduzca una descripción para este bloque de la secuencia.",
    "sequenceBlockIsSelective": "Esta bloque de la secuencia ha sido marcada como selectiva.",
    "sequenceBlockTitlePlaceholder": "Por favor, introduzca un título para esta bloque de la secuencia.",
    "sequenceBlocks": "Bloques de la Secuencia",
    "sequenceNumber": "No. de Secuencia",
    "session": "Sessión",
    "sessionAttributes": "Atributos de la Sesión",
    "sessionLearningMaterials": "Materiales de Aprendizaje de la Sesión",
    "sessionTitle": "Titulo de Sesión",
    "sessionTitleFilterPlaceholder": "Aplicar un Filtro por titulo, tipo, o estado de la publicación",
    "sessionTitlePlaceholder": "Entre en un titulo para esta sesión",
    "sessionType": "Tipo de Sesión",
    "sessionTypeConfirmRemoval": "¿Está seguro de que desea eliminar este tipo de sesión? Esta acción no se puede deshacer.",
    "sessionTypes": "Tipos de Sesiones",
    "sessionTypesFor": "Tipos de Sesiones para {subject}",
    "sessions": "Sesiones",
    "showAllMyActivities": "Mostrar todas mis actividades",
    "showCalendar": "Muestre Calendario",
    "showCourseMaterials": "Mostrar materiales del curso",
    "showFilters": "Enseñe Filtros",
    "showIcsFeed": "Mostrar Opciones de Fuente de Datos ICS",
    "showLearnerGroupEvents": "Mostrar todos los eventos para grupos de alumnos asignados",
    "showMore": "Mostrar más",
    "showNotesToStudents": "Mostrar Notas a Los Estudiantes",
    "showObjectives": "Mostrar objetivos",
    "showOnlyMyAdminActivities": "Mostrar solo mis actividades de administrador",
    "showOnlyMyInstructorActivities": "Mostrar solo las actividades de mi instructor",
    "showOnlyMyLearnerActivities": "Mostrar solo mis actividades de aprendizaje",
    "showResultsFor": "Mostrar Resultados Para",
    "showRolesInCourses": "Mostrar roles en cursos",
    "showRolesInProgramYears": "Mostrar roles en años de programa",
    "showRolesInPrograms": "Mostrar roles en programas",
    "showRolesInSessions": "Mostrar roles en sesiones",
    "showSessionEvents": "Mostrar todos los '<em>'{sessionTitle}'</em>' eventos",
    "showSessionMaterials": "Mostrar materiales de la sesión",
    "showSubgroupEvents": "Mostrar eventos para todos los grupos subordinados",
    "singleDay": "Un Solo Día",
    "singleGroup": "Solo grupo",
    "skipToMainContent": "Saltar al contenido principal",
    "smallGroupMessage": "Por favor seleccione al menos un grupo de alumnos para adjuntar a su ofrecimiento de grupos pequeños. Si usted desea programar este ofrecimiento sin grupos, favor de seleccionar el botón de \"ofrecimiento\" de arriba.",
    "smallGroups": "Grupos Pequeños",
    "sortMaterials": "Clasificar los materiales",
    "sortObjectives": "Clasificar los objetivos",
    "specialAttireIs_Required_": "Se '<strong><em>'require'</em></strong>' vestimenta especial",
    "specialAttireRequired": "Vestimenta Especial Requerido",
    "specialEquipment": "Equipo especial",
    "specialEquipmentIs_Required_": "Se '<strong><em>'require'</em></strong>' equipo especial",
    "specialEquipmentRequired": "Equipo Especial Requerido",
    "start": "Inicio",
    "startDate": "Fecha de Iniciar",
    "startLevel": "nivel de inicio",
    "startOver": "Empezar de Nuevo",
    "startTime": "Hora de Iniciar",
    "starts": "Empieza",
    "stateOrProvince": "Estado o Provincia",
    "status": "Estado",
    "statusCode": "Código de estado",
    "stewardingSchoolsAndDepartments": "Escuelas y Departamentos Administrativos",
    "stewardsManageTitle": "Maneje Administradores",
    "street": "Calle",
    "strong": "Fuerte",
    "student": "Estudiante",
    "studentAdvisorCount": "Hay {count, plural, =1 {1 consejero estudiantil} other {# consejeros estudiantiles}}",
    "studentAdvisors": "Consejeros Estudiantiles",
    "subCompetencyCount": "{count, plural, =1 {Hay 1 subcompetencia} other {Hay # subcompetencias}}",
    "subTerms": "Términos subordinados",
    "subgroupName": "Nombre del Subgrupo",
    "subgroups": "Grupos Subordinados",
    "subjectReports": "Informes de Sujetos",
    "successfullyAddedTerm": "Término Agregado Correctamente",
    "successfullyInvalidatedTokens": "Todas los tokens existentes fueron con éxito invalidadas",
    "successfullyRemovedTerm": "Término Eliminado Correctamente",
    "summary": "Resumen",
    "sunday": "Domingo",
    "supplementalCurriculum": "Plan de Estudios No Requerido",
    "table1ProgramExpectationsMappedToPcrs": "Tabla 1: Expectativas del programa asignadas a PCRS",
    "table2PrimaryInstructionalMethodByNonClerkshipSequenceBlock": "Tabla 2: Método de instrucción primario por bloque de secuencia de no rotación",
    "table3aNonClerkshipSequenceBlockInstructionalTime": "Tabla 3-A: Tiempo de instrucción del bloque de secuencia de no rotación",
    "table3bClerkshipSequenceBlockInstructionalTime": "Tabla 3-B: Tiempo de instrucción del bloque de secuencia de la rotación",
    "table4InstructionalMethodCounts": "Tabla 4: recuentos de métodos de instrucción",
    "table5NonClerkshipSequenceBlockAssessmentMethods": "Tabla 5: Métodos de evaluación de bloque de secuencia no rotación",
    "table6ClerkshipSequenceBlockAssessmentMethods": "Tabla 6: Métodos de evaluación del bloque de secuencia de la rotación",
    "table7AllEventsWithAssessmentsTaggedAsFormativeOrSummative": "Tabla 7: Todos los eventos con evaluaciones etiquetadas como formativas o sumativas",
    "table8AllResourceTypes": "Tabla 8: Todos los tipos de recursos",
    "targetCourse": "Curso de Destino",
    "taughtBy": "Ènsenada Por {instructors}",
    "term": "Término",
    "termCount": "{count, plural, =1 {1 tiene términos de vocabulario} other {# tienen términos de vocabulario}}",
    "termXappliedToYSessionsWithSessionTypeZ": "El término \"{term}\" del vocabulario \"{vocabulary}\" se aplica a {sessionsCount, plural, =1 {1 sesión} other {# sesiones}} con el tipo de sesión \"{sessionType}\".",
    "terms": "Términos",
    "termsBySessionType": "Términos por Tipo de Sesión",
    "termsManageTitle": "Maneje Términos",
    "thereAreXTerms": "{count, plural, =1 {Hay 1 término} other {Hay # términos}}",
    "thereAreXTypes": "{count, plural, =1 {Hay 1 tipo} other {Hay # tipos}}",
    "thisReportIsNoLongerAvailable": "Este informe ya no está disponible.",
    "thisTermHasSubTerms": "Este término tiene subtérminos.",
    "thursday": "Jueves",
    "time": "Hora",
    "timedRelease": "Lanzamiento Calculado",
    "timedReleaseAddEndDate": "Agregar Fecha de Finalización de Lanzamiento",
    "timedReleaseAddStartDate": "Agregar Fecha de Inicio de Lanzamiento",
    "timedReleaseClearEndDate": "Quitar Fecha de Finalización de Lanzamiento ",
    "timedReleaseClearStartDate": "Quitar Fecha de Inicio de Lanzamiento ",
    "timedReleaseNoSchedule": "Disponible inmediatamente cuando publicado ",
    "timedReleaseOnlyEndDate": "Disponible antes de {endDate}",
    "timedReleaseOnlyStartDate": "Disponible después de {startDate}",
    "timedReleaseStartAndEndDate": "Disponible a partir de {startDate} hasta {endDate}",
    "timezone": "Zona horaria",
    "title": "Titulo",
    "today": "Hoy",
    "token": "Token",
    "tokenInfo": "Tokens de la API se utilizan para obtener acceso a datos de Ilios. Su símbolo (token) es como una contraseña. - cualquier persona que lo tiene puede hacer cambios en su nombre. Lea más en la documentación en {apiDocsLink}.",
    "tooManyResults": "La búsqueda ha devuelto más de {count} resultados.  Para ver mejores resultados, intente su búsqueda otra vez con condiciones adicionales.",
    "topPagination": "Paginación superior",
    "total": "Total",
    "totalErrors": "{count, plural, =1 {Hay un error} other {Hay # errores}}",
    "totalIlmTime": " Tiempo de ILM {minutes} Minutos",
    "totalInstructionalTime": "Tiempo de Instrucción Total {minutes} Minutos",
    "totalTime": "Horas Totales",
    "totalWeeks": "Semanas totales",
    "transitionErrorMessage": "Lo sentimos! No le podemos conseguir donde pidió ir...",
    "tryHarder": "Esforzarse Más",
    "tuesday": "Martes",
    "type": "Tipo",
    "unPublishCourse": "No Publique El Curso",
    "unPublishProgram": "No Publique El Programa",
    "unPublishProgramYear": "No Publique Año de Programa",
    "unPublishSession": "No Publique La Sesión",
    "unPublishedSuccessfully": "No Publicado con Éxito",
    "unableToReconnect": "¡No se puede volver a conectar!",
    "unableToSyncUser": "Incapaz de sincronizar al usuario del directorio, por favor asegure el Campus ID es correcto.",
    "unassigned": "No asignado",
    "unassignedStudentsConfirmation": "{count, plural, =1 {Asignar 1 el usuario seleccionado a} other {Asignar # usuarios seleccionados a}}",
    "unassignedStudentsSummary": "{count, plural, =1 {Hay un estudiante que requiere asignación de cohorte} other {Hay # estudiantes que requieren asignación de cohorte}}",
    "unassignedStudentsSummaryTitle": "Estudiantes que Requieren Asignación de Cohorte",
    "undo": "Deshacer",
    "universalLocator": "Localizador universal de",
    "unlinkedObjectives": "Este curso tiene objetivo(s) no vinculados",
    "unlockCourse": "Desbloquea el curso",
    "unordered": "No Ordenado",
    "unsupportedBrowserFailure": "Su navegador no está soportado oficialmente por Ilios y no puede completar esta acción.  Por favor inténtalo de nuevo utilizando un navegador actualizado.",
    "unusedObjectives": "Objetivos no Utilizados",
    "upcomingActivities": "Mis Actividades para los próximos {days} días",
    "upcomingMaterials": "Mis Materiales de Aprendizaje para los próximos {days} días",
    "update": "Actualizar",
    "updateNow": "Actualizar Ahora ",
    "updatePending": "Actualización Pendiente",
    "updateUserFromDirectory": "Actualizar este registro del usuario del directorio del campus.",
    "uploadDate": "Fecha de carga",
    "uploadGroupAssignments": "Cargar Asignaciones de Grupos",
    "uploadUsers": "Archivo con datos de usuarios (csv, tsv, tx)",
    "uploadedGroup": "Grupo Subido",
    "url": "URL",
    "userExistsInGroupHierarchy": "El usuario ya existe en el grupo de nivel superior {groupTitle} o en uno de sus subgrupos.",
    "userExistsMultipleTimesInUpload": "Este usuario ya existe en la carga.",
    "userMenu": "Menú del Usuario",
    "userNotAddableFromDirectory": "ste usuario está faltando información requerida y no se puede agregar",
    "userNotInGroupCohort": "El usuario no está en la cohorte de este grupo: {cohortTitle}",
    "userRole": "Función de Usuario",
    "userRoles": "Funciones de usuario",
    "username": "Nombre de Usuario",
    "users": "Usuarios",
    "usersCalendar": "Calendario de{name}",
    "usersSelected": "{count, plural, =1 {1 usuario seleccionado} other {# usuarios seleccionados}}",
    "validUntil": "¿Cuándo debe este símbolo (token) deje de funcionar??",
    "validUsers": "Usuarios Válidos",
    "verificationPreviewFor": "Vista previa de verificación para {name}",
    "view": "Vista",
    "viewAll": "Ver Todos",
    "virtualLearningLink": "Enlace de Aprendizaje Virtual",
    "virtualSessionLink": "Enlace de Sesión Virtual",
    "visibleToStudents": "visible para los estudiantes",
    "visualizations": "Visualizaciones",
    "visualizeCourseObjectives": "Visualizar los objetivos del curso ",
    "vocabularies": "Vocabularios",
    "vocabulariesBySessionType": "Vocabularios por Tipo de Sesión",
    "vocabulary": "Vocabulario",
    "vocabularyTerms": "Términos del Vocabulario",
    "vocabularyTermsFor": "Términos del Vocabulario para {subject}",
    "waitSaving": "Salvando... un momento...",
    "weak": "Débil",
    "wednesday": "Miércoles",
    "week": "Semana",
    "weekAtAGlance": "Semana de un vistazo",
    "weekOf": "Semana de {date}",
    "weeks": "Semanas",
    "when": "Cuando",
    "whichIs": "cuál es",
    "whitecoatsSlashSpecialAttire": "Abrigos blancos / vestimenta especial",
    "withXmoreOfferings": "con {count, plural, =1 {una ofrenda mas} other {# ofertas más}}",
    "write": "Escribir",
    "xTermsFromVocabYusedWithSessionTypeZ": "{termsCount, plural, =1 {1 término} other {# términos}} del vocabulario \"{vocabulary}\" {termsCount, plural, =1 {se aplica } other {se aplican}} a {sessionsCount, plural, =1 {1 sesión} other {# sesiónes}} on el tipo de sesión \"{sessionType}\".",
    "year": "Año",
    "yes": "Sí",
    "yesPopulateGroup": "¡Sí! Añada la cohorte entera a mi nuevo grupo.",
    "zipCode": "Código postal"
  }
}], ["fr", {
  "errors": {
    "accepted": "{description} doit être accepté",
    "after": "{description} doit être après {after}",
    "agreementRequired": "Entente ou autre justification requise pour le téléchargement",
    "before": "{description} doit être avant {before}",
    "blank": "{description} ne doit pas être blanc",
    "collection": "{description} doit être un collection",
    "confirmation": "{description} ne correspond pas de {on}",
    "date": "{description} doit être une date valide",
    "description": "Ce champ",
    "duplicateUsername": "Ce nom d'utilisateur est déjà pris par un autre compte utilisateur.",
    "email": "{description} doit être une e-mail valide",
    "empty": "{description} ne doit pas être vide",
    "equalTo": "{description} doit être égale à {is}",
    "even": "{description} doit être une chiffre pair",
    "exclusion": "{description}est reservé",
    "greaterThan": "{description} doit être supérieure à {gt}",
    "greaterThanOrEqualTo": "{description} doit être supérieure ou ègale à {gte}",
    "inclusion": "{description} ne figure pas dans la liste",
    "invalid": "{description} est invalide",
    "invalidChangeAlertRecipients": "Cette liste de destinataires d'alertes de changement contient des adresses e-mail invalides.",
    "lessThan": "{description} doit être inférieure à {lt}",
    "lessThanOrEqualTo": "{description} doit être supérieure ou inférieure à {lte}",
    "missingFile": "Fichier manquant",
    "notANumber": "{description} doit contenir une valeur numérique",
    "notAnInteger": "{description} doit être un entier",
    "odd": "{description} doit étre une chiffre impair",
    "onOrAfter": "{description} doit être sur ou après {onOrAfter}",
    "onOrBefore": "{description} doit être en ou avant {onOrBefore}",
    "otherThan": "{description} doit être une valeur autre de {value}",
    "phone": "{description} doit être une téléphone valide",
    "positive": "{description} doit être une chiffre positif",
    "present": "{description} doit rester vide",
    "reportMissingAcademicYear": "Année Scolaire requis",
    "reportMissingCompetency": "Compétence requis",
    "reportMissingInstructor": "Instructeur requis",
    "reportMissingInstructorGroup": "Groupe des Instructeurs requis",
    "reportMissingMeshTerm": "terme de MeSH requis",
    "reportMissingObjectForCompetency": "connexion requis quand `compétence` est le sujet",
    "reportMissingObjectForInstructor": "connexion requis quand `instructeur` est le sujet",
    "reportMissingObjectForInstructorGroup": "connexion requis quand `groupe des instructeurs` est le sujet",
    "reportMissingObjectForMeshTerm": "connexion requis quand `terme de MeSH` est le sujet",
    "reportMissingObjectForProgram": "connexion requis quand `diplôme` est le sujet",
    "reportMissingObjectForSessionType": "connexion requis quand `type de Seance` est le sujet",
    "reportMissingObjectForTerm": "connexion requis quand `terme` est le sujet",
    "reportMissingProgram": "Diplôme requis",
    "reportMissingProgramYear": "Année Diplôme requis",
    "reportMissingSessionType": "Type de Seance requis",
    "reportMissingTerm": "Terme requis",
    "required": "{description} est obligatoire",
    "singular": "{description} ne doit pas être un collection",
    "tooLong": "{description} est trop long (maximum de {max} caractères)",
    "tooShort": "{description} est trop court (minimum de {min} caractères)",
    "url": "{description} doit être une URL valide",
    "wrongDateFormat": "{description} doit être en format de {format}",
    "wrongLength": "{description} n’est pas à la bonne longueur (soit ainsi {is} caractères)"
  },
  "general": {
    "aamcMethod": "AAMC Méthode",
    "aamcPcrs": "AAMC PCRS",
    "aamcSchoolId": "Identifiant d'école AAMC (\"Identifiant d'institution\")",
    "academicLevel": "Niveau scolaire",
    "academicLevels": "Niveaux scolaire",
    "academicYear": "Année Scolaire",
    "academicYears": "Années Scolaire",
    "accessAllMaterialsForThisCourse": "Accéder à tout le matériel d'étude pour ce cours",
    "accommodationIsRequiredForLearnersInSubgroups": "Des aménagements sont nécessaires pour les apprenants des sous-groupes suivants: {groups}",
    "accommodationIsRequiredForLearnersInThisGroup": "Des aménagements sont nécessaires pour les apprenants de ce groupe",
    "accountEnabled": "Compte Activé",
    "actions": "Actions",
    "activate": "Activer",
    "active": "Actif",
    "activeFilters": "Filtres actifs",
    "add": "Ajouté",
    "addCohort": "Ajouté cohorte",
    "addNew": "Ajouté Neuf",
    "admin": "Admin",
    "administrator": "Administrateur",
    "administratorCount": "Il y a {count, plural, =1 { un administrateur} other {# administrateurs}}",
    "administratorEmail": "Courriel d'administrateur",
    "administratorEmailPlaceholder": "email@example.edu",
    "administratorEmails": "Courriels d'administrateur",
    "administrators": "Administrateurs",
    "advancedOptions": "Options avancées",
    "all": "Tous",
    "allAcademicYears": "Toutes Années Scolaires",
    "allCourses": "Tous les Cours",
    "allEvents": "Tous les Événements",
    "allMaterials": "Tous les matériaux",
    "allOtherMembers": "Tous les autres membres du {topLevelGroupTitle}",
    "allSchools": "Toutes les écoles",
    "allVocabularies": "Touts vocabulaires",
    "allWeeks": "Toutes les Semaines",
    "anything": "Quelque chose",
    "apiVersionMismatch": "API  conflit de version",
    "apiVersionMismatchDetails": "Il s'agit généralement d'une erreur temporaire dans votre navigateur; Ilios est en mode lecture seule jusqu'à ce qu'il soit résolu. Si la mise à jour ne vous aide pas, veuillez aviser un administrateur ou le propriétaire de la technologie du système de cette erreur. Vous pouvez également essayer un autre navigateur.",
    "assessment": "Évaluation",
    "assessmentMethods": "Méthodes d'Évaluation",
    "assessmentOption": "Option d'Évaluation",
    "assessments": "Évaluations",
    "assignedTerms": "Termes assignées",
    "associatedCourses": "Cours Associés",
    "associatedGroups": "Groupes Associés",
    "associatedWith": "associée de",
    "attendanceIsRequired": "Présence requise",
    "attendanceIs_Required_": "Présence '<strong><em>'requise'</em></strong>'",
    "attendanceRequired": "Participation Requise",
    "attribute": "Attribut",
    "author": "Auteur",
    "autoUpdatingSeconds": "{count, plural, =1 { Mise à jour automatique en 1 seconde...} other { Mise à jour automatique en # secondes...}}",
    "available": "Disponible",
    "availableCohorts": "Cohortes Disponsibles",
    "availableInstructors": "Instructeurs Disponibles",
    "availableInstructorsAndInstructorGroups": "Instructeurs et groupes d'instructeurs disponibles",
    "availableLearnerGroups": "Groupes d'apprenants disponsibles",
    "availableLearners": "Apprenants disponibles",
    "averageHoursOfInstructionPerWeek": "Nombre moyen d'heures d'enseignement par semaine",
    "back": "Retour",
    "backToAdminDashboard": "Rétour au Page Admin",
    "backToCalendar": "Retour au Calendrier",
    "backToCourse": "Retour au Cours",
    "backToCourses": "Retour à liste",
    "backToDashboard": "Retour à tableau de bord",
    "backToDetails": "Retour à détails de la Séance",
    "backToInstructorGroups": "Retourner à liste des groupes des instructeurs",
    "backToProgramYear": "Retour à Année de Diplôme",
    "backToProgramYears": "Retour à Années de Diplôme",
    "backToPrograms": "Retour à Diplôme",
    "backToReport": "Retour à rapport",
    "backToReports": "Retour à rapports",
    "backToSchools": "Retour aux écoles",
    "backToSessionList": "Retour à Liste du Séances",
    "backToTableOfContents": "Retour à la table des matières",
    "backToTitle": "Retour à {title}",
    "bad": "Mal",
    "badCredentials": "Nom d'utilisateur ou mot de passe incorrect",
    "beforeOrAfterMidday": "Avant ou après midi",
    "bottomPagination": "Pagination en bas",
    "calendar": "Calendrier",
    "calendarOff": "Calendrier Éteindé",
    "calendarOn": "Calendrier Allumé",
    "campusId": "Campus ID",
    "campusNameOfRecord": "Nombre de registro del campus",
    "canNotContinueWithInvalidRecords": "Ne peut pas continuer avec ces rapports invalides, fixez s'il vous plaît et retéléchargez le fichier.",
    "canNotDeleteLearnerGroupWithAssociatedCourses": "Ce groupe est rattaché à {courseCount}  cours et ne peut être supprimé.",
    "cancel": "Annul",
    "changeAlertRecipients": "Destinataires des alertes de changement",
    "changeAlertRecipientsPlaceholder": "email1@example.edu, email2@example.edu",
    "childSequenceOrder": "Ordre séquentiel des enfants",
    "chooseCohortTitle": "Choisi objectif mère pour",
    "chooseFile": "Choisir un Fichier",
    "citation": "Citation",
    "city": "Ville",
    "classOf": "Classe de {year}",
    "clearDates": "Supprimer dates",
    "clearErrors": "Supprîme les Erreurs et Retour à Ilios",
    "clearFilters": "Effacerez les Filtres",
    "clerkship": "Stage",
    "clerkshipSequenceBlocks": "Blocs de séquence de stage",
    "clerkshipType": "Genre de Stage",
    "clickForMore": "Cliquez ici pour en savoir plus",
    "clickToAddDescription": "Cliquez pour ajouter une description",
    "clickToAddTermDescription": "Cliquez pour ajouter des notices descriptives",
    "clickToEdit": "Clicquez pour modifier",
    "close": "Fermé",
    "cohort": "Cohorte",
    "cohortMembersNotInGroup": "Membres de la Cohorte sans affectation à {groupTitle} ",
    "cohorts": "Cohortes",
    "cohortsManageTitle": "Manager des Cohortes",
    "collapse": "réduire",
    "collapseDetail": "Masquer Détails",
    "color": "Couleur",
    "competencies": "Compétences",
    "competenciesManageTitle": "Manager des Compétences",
    "competency": "Compétence",
    "competencyDomain": "Domaine de Compétence",
    "complete": "Accompli",
    "completeSessions": "Séances complète: prêt à publier",
    "confirmLogout": "Vous avez réussi accomplir une fermeture de session en Ilios. Afin de nous aider à protéger votre compte et de la securité des autres, s'il vous plait fermer toutes les fenêtres du navigateur.",
    "confirmObjectiveRemoval": "Êtes vous sûr de vouloir supprimer cet objectif?",
    "confirmObjectiveRemovalMultipleSessionObjectives": "Vous êtes sur le point de supprimer cet objectif de cours, qui est lié à {count} objectifs de séance. Cela supprimera également ces liens. Êtes-vous certain de vouloir continuer?",
    "confirmRemoval": "Êtes-vous sûr vous voulez supprimer cette matériel d'étude?",
    "confirmRemove": "Êtes-vous sûr vous voulez supprimer cette offre avec {learnerGroupCount} groupes d'apprenants?  Ça action ne peut pas être défait.",
    "confirmRemoveCourse": "Êtes-vous sûr vous voulez supprimer ce cours, avec {publishedOfferingCount} offres publié? Cela supprimera toutes sessions et offres pour ce cours, et ne peut pas être défait.",
    "confirmRemoveInstructorGroup": "Êtes-vous sûr vous voulez supprimer cette groupe des instructeurs, avec {instructorCount} membres? Ça action ne peut pas être défait.",
    "confirmRemoveLearnerGroup": "Êtes-vous sûr vous voulez supprimer cette groupe d'apprenants, avec {subgroupCount} sous-groupes? Ça action ne peut pas être défait.",
    "confirmRemoveProgram": "Êtes-vous certain que vous voulez supprimer ce diplôme? Cette action ne peut être annulée.",
    "confirmRemoveProgramYear": "Êtes-vous certain que vous voulez supprimer cette année de diplôme? Cette action va supprimer tous les cohortes et groupes des étudiants associées, et liaisons avec {courseCount} des cours, et ne peut être annulée.",
    "confirmSessionRemoval": "Êtes vous sûr de vouloir supprimer cette séance?",
    "confirmVocabularyRemoval": "Êtes vous sûr de vouloir supprimer cette vocabulaire?",
    "connectionLost": "Connexion perdu",
    "contentAuthor": "Auteur",
    "continue": "Continuez",
    "copiedIcsFeedUrl": "Copié mon lien ICS avec succès",
    "copiedSuccessfully": "Copié avec succès",
    "copy": "Copie",
    "copyIcsFeedUrl": "Copier mon lien ICS",
    "copyLink": "Copier le lien",
    "copyNewToken": "Copier nouveau jeton",
    "copySession": "Copier Séance",
    "copySessionSummary": "Vous êtes sur le point la copie sur cette séance (sans données de calendrier) dans le cours choisi. La nouvelle seéance inclura tous les objectifs, des termes et les matériels d'étude. Continuer le clic \"oui\". Retourner à votre clic de session actuel \"annul\".",
    "copySuccess": "Copie achevée avec succès",
    "copyWithLearners": "Copiér avec étudiants",
    "copyWithoutLearners": "Copiér sans étudiants",
    "copyrightAgreement": "Le fichier J'envoie est ma propre ou j'avoir la permission expresse de reproduire et / ou distribuer cet article, ou l'utilisation de celui-ci ici a été jugée admissible par la doctrine juridique de l'utilisation équitable. Ce fichier ne contient pas protégé information sur la santé, et l'utilisation de celui-ci ici est en conformité avec le gouvernement et l'Université des politiques sur le droit d'auteur et à la sécurité de l'information et les directives de mon institution pour la conduite professionnelle.",
    "copyrightPermission": "Droit d’Auteur",
    "copyrightRationale": "Raison du droit d'auteur",
    "couldNotFindUserCampusId": "Ne pouvait pas trouver utilisateur avec le Campus ID {campusId}",
    "countAsOneOffering": "Comptent pour une offre",
    "countTotal": "{total} au total",
    "country": "Pays",
    "course": "Cours",
    "courseDirector": "Directeur de Cours",
    "courseLearningMaterials": "Matériels d'Étude du Cours",
    "courseLevel": "Niveau du cours {level}",
    "courseLevels": "Niveaux de Cours",
    "courseMaterials": "Matériels du Cours",
    "courseNotFound": "cours introuvable",
    "courseObjective": "Objectif du Cours",
    "courseObjectives": "Objectifs du Cours",
    "courseOrSessionType": "Cours / Type de séance",
    "courseRollover": "Roulement Cours",
    "courseRolloverSuccess": "Roulement achevée avec succès",
    "courseRolloverSummary": "Vous êtes sur le point le roulement ce cours dans l'année universitaire choisie, avec toutes les options choisies. Continuer, cliquer \"done\". Pour retourner à votre cours actuel, le clic \"annul\"",
    "courseRolloverYearUnavailable": "Cours déja existant",
    "courseTitle": "Titre de Cours",
    "courseTitleFilterPlaceholder": "Filtre par titre de cours",
    "courseTitlePlaceholder": "Ajoutez titre par ce cours",
    "courseVisualizations": "Cours Visualisations",
    "courseVisualizationsInstructorNoData": "{instructor} n'enseigne aucune séance dans ce cours.",
    "courseVisualizationsInstructorsGraphNoData": "Aucun instructeur n'a été lié à aucune session de ce cours.",
    "courseVisualizationsNoSessions": "Ce cours n'a pas de séances.",
    "courseVisualizationsSessionTypeGraphNoData": "Aucun terme de vocabulaire n'a été lié à une session {sessionType} dans ce cours.",
    "courseVisualizationsTermGraphNoData": "Le terme de vocabulaire {term} n'a été lié à aucune session de ce cours.",
    "courseVisualizationsVocabularyGraphNoData": "Aucun terme de vocabulaire {vocabulary} n'a été lié à aucune session de ce cours.",
    "courses": "Les Cours",
    "coursesAndSessions": "Des Cours et Séances",
    "create": "Créez un nouvel utilisateur",
    "createBulk": "Envoyez utilisateurs multiples",
    "createNew": "Créer Neuf",
    "createNewGroup": "Créez Ce Groupe",
    "currentCompetency": "Compétence Actuelle",
    "currentSchool": "Écôle Actuelle",
    "currentlySearchingPrompt": "Recherchent...",
    "curriculumInventory": "Inventaire des programmes d'études",
    "curriculumInventoryInstitutionalInfo": "Inventaire des programmes d'études informations institutionnelles",
    "curriculumInventoryReport": "Rapport d'inventaire des programmes d'études",
    "curriculumInventoryReportRollover": "Roulement Rapport d'inventaire des programmes d'études",
    "curriculumInventoryReportRolloverSuccess": "Roulement achevée avec succès",
    "curriculumInventoryReportRolloverSummary": "Cette action copiera la structure de ce rapport à utiliser dans votre année cible. Il ne copiera pas les informations de cours, uniquement la structure de bloc de séquence de niveau supérieur. Vous devrez ajouter les informations de cours appropriées et modifier les dates de début et de fin du bloc de séquence une fois que vous aurez reconduit la structure de rapport existante.",
    "curriculumInventoryReports": "Rapports d'inventaire des programmes d'études",
    "dashboard": "Tableau de Bord",
    "dashboardNavigation": "Naviguer dans le tableau de bord",
    "date": "Date",
    "dateTime": "Date/Temps",
    "day": "Jour",
    "deactivate": "Désactiver",
    "defaultInstructors": "Instructeurs par Défaut",
    "defaultInstructorsNotLoaded": "(Instructeurs par défaut ne seront pas chargés: s'il vous plaît entrer la valeur souhaitée.)",
    "defaultLocation": "Localisation par Défaut",
    "defaultLocationNotLoaded": "(Localisation par défaut ne sera pas chargé: s'il vous plaît entrer la valeur souhaitée.)",
    "defaultNotLoaded": "Par défaut non chargé",
    "defaultVirtualLearningLink": "Address d’Étude Virtuel par Défaut",
    "delete": "Supprimer",
    "deleteCourse": "Supprimer le cours",
    "departments": "Facultés",
    "deprecatedAbbreviation": "obs.",
    "description": "Description",
    "deselectUser": "Désélectionner l'utilisateur ",
    "details": "Détails de Cours",
    "developer": "Administrateur",
    "director": "Directeur",
    "directorCount": "Il y a {count, plural, =1 {un directeur} other {# directeurs}}",
    "directors": "Directeurs",
    "disableUser": "Désactiver compte d’utilisateur",
    "disabled": "désactivée",
    "displayName": "Nom d’Affichage",
    "doesNotMatchUserRecord": "Téléchargé {description} ne correspond pas aux informations dans Ilios, qui est \"{record}\"",
    "domain": "Domaine",
    "done": "Fini",
    "download": "Télécharger",
    "downloadCompetencyMap": "Télécharger la tableau de compétences",
    "downloadResults": "Télécharger les indices",
    "draft": "Provisoire",
    "dueBefore": "Avant",
    "dueBy": "Avant",
    "duePriorTo": "Dû avant",
    "duration": "Durée",
    "durationHours": "{count, plural, =1 {1 une heure} other {# heures}}",
    "durationInDays": "Durée (en Jours)",
    "durationInYears": "Durée (en Années)",
    "durationMinutes": "{count, plural, =1 {1 une minute} other {# minutes}}",
    "edit": "Edite",
    "educationalYear": "Année scolaire",
    "email": "Email",
    "emails": "Emails",
    "enabled": "Activé",
    "end": "Terminé",
    "endDate": "Jour Terminé",
    "endLevel": "niveau final",
    "endTime": "Heure Terminé",
    "ends": "Terminé",
    "error": "Erreur",
    "errorDisplayMessage": "Désolé! Quelque chose s'est passé mal avec votre demande. Essayez s'il vous plaît de rafraîchir ou vérifier en arrière plus tard.",
    "errorSavingAuthentication": "Les comptes ont été créés pour ces utilisateurs, mais ils ne pourront pas à la connexion. Ceci arrive d'habitude quand le nom d'utilisateur existe déjà, mais appartient à un autre utilisateur. Cliquez S'il vous plaît sur chaque utilisateur et créez un nom d'utilisateur et un mot de passe pour eux.",
    "errorSavingUser": "Ces utilisateurs n'avait pas été sauvé. Vérifiez qu'ils n'existent pas déjà.",
    "errors": "Erreurs",
    "etAl": "et al.",
    "eventNotFoundExplanation": "L'événement que vous avez essayé d'atteindre n'est plus disponible ou vous avez suivi un lien utilisateur personnalisé qui n'est pas partageable. Si vous continuez à rencontrer des problèmes, veuillez contacter votre service d'assistance Ilios.",
    "eventNotFoundTitle": "Evénement introuvable",
    "exclude": "Exclure",
    "excludeFromSync": "Exclure de Sync",
    "existingGroup": "Groupe Existant ",
    "expand": "étendre",
    "expandDetail": "Afficher Détails",
    "externalId": "ID de Cours",
    "file": "Fichier",
    "file-audio": "Fichier audio",
    "file-pdf": "Fichier PDF",
    "file-powerpoint": "Fichier PowerPoint",
    "file-video": "Fichier vidéo",
    "fileSizeError": "Ce dossier est trop grand. Taille maximale est {maxSize}).",
    "fileTypeError": "Mal fichier téléchargé : {fileType} ne semble pas être un fichier correctement délimité.",
    "fileUploadError": "Nous n'avons pas pu télécharger ce dossier. Assurez S'il vous plaît que vous êtes connectés au réseau. Si ce problème persiste merci de nous faire savoir.",
    "filterByNameOrEmail": "Filtre par nom ou email",
    "filterByProgram": "Filtre par diplôme",
    "filterBySchool": "Filtre par école",
    "filterByTitle": "Filtre par titre",
    "filterByYear": "Filtre par année",
    "filterChartPlaceholder": "Commencez à taper pour filtrer ce graphique",
    "filterPlaceholder": "Commencez à taper pour filtre la liste",
    "finalErrorDisplayMessage": "Zoinks! Quelque chose ne vas pas du tout. S'il vous plaît rafraîchir votre navigateur et prévenez-nous à support@iliosproject.org si vous continuez à voir ce message.",
    "finalResults": "Résultats Finaux",
    "finalize": "Finaliser",
    "finalizeReportConfirmation": "En finalisant ce rapport, vous le sauverez dans son état actuel à la base de données Ilios comme un objet de référence permanent et éditez pas plus loin sera possible.",
    "finalized": "Finalisé",
    "finalizingReport": "Finalisation rapport, cela peut prendre un certain temps ...",
    "findDirector": "Découvrir Directeur",
    "findInstructorOrGroup": "Trouver Instructeur ou Groupe",
    "findLearners": "Trouver des apprenants",
    "first": "Première",
    "firstName": "Prénom",
    "firstOffering": "Premier Offre",
    "for": "Pour",
    "formative": "formative",
    "formerStudent": "Ancien Étudiant",
    "forward": "Avancer",
    "friday": "Vendredi",
    "fullName": "Nom complet",
    "globalSearchPlaceholder": "Trouver des utilisateurs...",
    "go": "Aller",
    "goToNextYear": "Aller à l'année prochaine",
    "goToPreviousYear": "Aller à l'année précédente",
    "goToUser": "Présentant enregistrement d'utilisateur en Ilios",
    "good": "Bon",
    "groupByCompetencies": "Groupe par Compétences",
    "groupMembers": "Membres du groupe courant",
    "groupName": "Nom de Groupe",
    "groups": "Groupes",
    "hideCalendar": "Cacher Calendrier",
    "hideCourseMaterials": "Masquer les supports de cours",
    "hideFilters": "Cachez les Filtres",
    "hideIcsFeed": "Masquer les options d'alimentation ICS",
    "hideObjectives": "Masquer les objectifs",
    "hideRolesInCourses": "Masquer les rôles dans les cours",
    "hideRolesInProgramYears": "Masquer les rôles dans les années du programme",
    "hideRolesInPrograms": "Masquer les rôles dans les programmes",
    "hideRolesInSessions": "Masquer les rôles dans les sessions",
    "hideSessionMaterials": "Masquer les supports de session",
    "home": "Accueil",
    "hour": "Heure",
    "hours": "Heures",
    "icsAdminInstructions": "Pour ajouter le calendrier d'un utilisateur à des services ou applications autre, devront utiliser cette URL. Cette URL comme un mot de passe. Toutes les personnes qui le connaissent pouvez voir le calendrier de cet utilisateur!",
    "icsFeed": "Données de ICS",
    "icsInstructions": "Pour ajouter votre calendrier à des services ou applications autre, utilisez cette URL. Cette URL comme un mot de passe. Toutes les personnes qui le connaissent pouvez voir votre calendrier!",
    "id": "ID",
    "ignore": "Ignorer",
    "ilios": "Ilios",
    "iliosUpdatePending": "hourra! Nous avons fait Ilios mieux. Vous obtiendrez le nouveau truc sur votre connexion prochaine, ou cliquerez pour mettre à jour maintenant.",
    "iliosUserGuide": "Ilios Guide d'utilisation",
    "ilm": "ILM",
    "ilmDue": "ILM - Échéance",
    "in": "en",
    "inProgress": "En Cours",
    "inactive": "inactif",
    "include": "Inclure",
    "includedInGrade": "Inclus dans le grade",
    "incompleteSessions": "Séances incomplète: ne peut être pas publiée",
    "independentLearning": "Apprentissage autonome",
    "independentLearningActivities": "Apprentissage autonome Activités",
    "instructing": "Enseignement",
    "instructionalMethod": "Modalité d'Instruction",
    "instructionalMethods": "Modalités d'Instruction",
    "instructionalNotes": "Notes Didactiques",
    "instructor": "Instructeur",
    "instructorGroup": "Groupe des Instructeurs",
    "instructorGroupMembers": "Membres du groupe d'instructeurs",
    "instructorGroupTitle": "Titre de Groupe des Instructeurs",
    "instructorGroupTitleFilterPlaceholder": "Filtre par Titre de Groupe des Instructeurs",
    "instructorGroupTitlePlaceholder": "Ajoutez une titre pour cette groupe des instructeurs",
    "instructorGroups": "Groupes des Instructeurs",
    "instructors": "Instructeurs",
    "instructorsAndInstructorGroups": "Instructeurs et Groupes des Instructeurs",
    "instructorsAndInstructorGroupsWithCount": "Instructeurs ({instructorCount}) et Groupes des Instructeurs ({instructorGroupCount})",
    "instructorsManageTitle": "Manager Instructeurs",
    "invalidDatetimes": "Dates/Heures invalides",
    "invalidUsers": "Utilisateurs non valides",
    "invalidateTokens": "Invalider tous les jetons",
    "invalidateTokensConfirmation": "Cette action va effacer tous les jetons de l’API. Vouz devrez générer nouveaux jetons pour toutes des vos applications.  Êtes vous sûr de vouloir le faire?",
    "isSelective": "Est sélectif",
    "isTrack": "Est une piste",
    "itemCode": "Code d'article",
    "language": {
      "en-us": "English (en)",
      "es": "Español (es)",
      "fr": "Français (fr)"
    },
    "last": "Dernier",
    "lastName": "Nom de famille",
    "lastUpdate": "Dernière mise à jour",
    "leadership": "Direction",
    "learner": "Apprenant",
    "learnerAssignments": "{groupTitle} affectations d'étudiant",
    "learnerGroupTitle": "Titre de groupe d'apprenants",
    "learnerGroupTitleFilterPlaceholder": "Filtre par titre de groupe d'apprenants",
    "learnerGroupTitlePlaceholder": "Ajoutez une titre pour cette groupe d'apprenants",
    "learnerGroups": "Groupes d'Étudiants",
    "learnerGroupsManageTitle": "Manager groupes d'apprenants",
    "learners": "Étudiants",
    "learnersAndLearnerGroups": "Étudiants et Groupes d'Étudiants",
    "learnersAndLearnerGroupsWithCount": "Étudiants ({learnerCount}) et Groupes d'Étudiants ({learnerGroupCount})",
    "learning": "Apprentissages",
    "learningMaterial": "Matériel d'Étude",
    "learningMaterialManageTitle": "Manager Matériels d'Étude",
    "learningMaterials": "Matériels d'Étude",
    "learningMaterialsSummary": "Résumé Matériels d'Étude",
    "level": "Niveau",
    "link": "Lien web",
    "linkedCompetencies": "Compétences Liés",
    "linkedCompetencyCount": "{count, plural, =1 {1 présente un compétence líé} other {# présentes des compétences líés}}",
    "listByPriority": "Liste par priorité",
    "lmDescriptorTitle": "Choisi MeSH pour les matériels d'étude",
    "loading": "Chargement Ilios",
    "loadingEvents": "Rassembler les événements...",
    "loadingMaterials": "Chargement Matériels...",
    "loadingSessionTypes": "Chargement des genres de session...",
    "location": "Locale",
    "lockCourse": "Verrouiller le cours",
    "login": "Login",
    "logo": "Ilios Logo",
    "logout": "Déconnexion",
    "makeRecurring": "Activité Récurrente",
    "manage": "Administrer",
    "manageAPITokens": "Gérer des jetons de l’API",
    "manageCompetencies": "Manager des Compétences",
    "manageDefaultInstructors": "Gérer les instructeurs par défaut",
    "manageEmails": "Gérer les emails",
    "manageGroupMembership": "Gérer l'appartenance au groupe",
    "manageInstitutionalInfo": "Manager les informations institutionnelles du CIR",
    "manageLeadership": "Gérer Dirigeants",
    "manageLearners": "Manager Étudiants",
    "manageSessionAttributes": "Gérer Attributs de Séance",
    "manageUsers": "Gérer les utilisateurs",
    "manageUsersSummaryTitle": "utilisateurs d'Ilios",
    "manageVocabularies": "Manager vocabulaires",
    "markAsScheduled": "Faire à prévu",
    "matchGroups": "Départagez les Groupes ",
    "materials": "Matériels",
    "matriculationYear": "Année de immatriculation",
    "maximum": "Maximum",
    "members": "Membres",
    "menu": "Ilios Menu",
    "mesh": "MeSH",
    "meshCount": "{count, plural, =1 {1 a des MeSH} other {# ont MeSH}}",
    "meshManageTitle": "Manager MeSH",
    "meshTerm": "Terme de MeSH",
    "meshTerms": "Termes de MeSH",
    "message": "Message",
    "middleName": "Deuxième Prénom",
    "minimum": "Minimum",
    "minute": "Minute",
    "minutes": "Minutes",
    "missingCohortMessage": "S'il vous plait ajouter au moins un cohort à ce cours.",
    "missingCompetenciesMessage": "S'il vous plaît ajouter au moins une compétence pour cette année de diplôme.",
    "missingCourseObjectivesMessage": "S'il vous plait ajouter au  moins d'objectif au cours.",
    "missingItems": "Objets Manquants",
    "missingPassword": "Nécessite un mot de passe",
    "missingRequiredUsername": "'Nom d'Utilisateur' est requis pour login; Cet utilisateur ne pourra pas login jusqu'à qu'un Nom d'Utilisateur s'affiche.",
    "missingUsername": "Nécessite un nom d'utilisateur",
    "modifyUserPassword": "Cliquez ici pour remettre à zéro votre mot de passe.",
    "monday": "Lundi",
    "month": "Mois",
    "moreInputRequiredPrompt": "Continuez à taper...",
    "moveToGroup": "{count, plural, =1 {Placer l’étudiant à {groupTitle}} other {Placer # étudiants à {groupTitle}}}",
    "multiDay": "de Plusieurs Jours",
    "multiday": "Plusieurs Jours",
    "multidayEvents": "Événements de plusieurs jours",
    "multiple": "Multiple",
    "multipleGroups": "Plusieurs groupes",
    "multipleUsersFoundWithCampusId": "Plusieurs utilisateurs trouvés avec le Campus ID  {campusId}",
    "mustBeSameDayOfWeekAsCurrentStartDate": "Doit être le même jour de la semaine que le courant date de début",
    "myCalendar": "Mon Calendrier",
    "myCourses": "Mes Cours",
    "myLearningMaterials": "Mes Matériels d'étude",
    "myMaterials": "Mes Matériels d'étude",
    "myProfile": "Mon profil",
    "mySchedule": "Mon Calendrier (liste)",
    "name": "Nom",
    "narrative": "narrative",
    "navigation": "Navigation",
    "navigationCompleteText": "La navigation sur la page Ilios est terminée. Vous pouvez maintenant naviguer dans le contenu de la page comme vous le souhaitez.",
    "newCourse": "Cours neuf",
    "newCurriculumInventoryReport": "Nouveau Rapport d'inventaire des Programmes d'études",
    "newDomain": "Domaine nouvelle",
    "newInstructorGroup": "Groupe des Instructeurs nouveau",
    "newLearnerGroup": "Groupe d'apprenants nouvelle",
    "newObjective": "Nouvel Objectif",
    "newObjectiveSaved": "Nouvel objective sauvé",
    "newOffering": "Nouvelle Offre",
    "newProgram": "Diplôme Nouveau",
    "newProgramYear": "Année de diplôme neuf",
    "newReport": "Nouveau rapport",
    "newSchool": "École nouvelle",
    "newSequenceBlock": "Nouveau bloc de séquence",
    "newSession": "Session neuf",
    "newTerm": "Nouveau terme",
    "newToken": "Nouveau jeton",
    "newUpdates": "Nouvelles mises à jour",
    "newUser": "Nouvel utilisateur",
    "newUsersCreatedSuccessfully": "Nouveaux utilisateurs crées avec succès",
    "newUsersCreatedWarning": "Certains utilisateurs ont été créés, mais il y avait des erreurs.",
    "next": "Proch.",
    "nextXDays": "{days} prochains jours ",
    "no": "Non",
    "noAccountExists": "Votre compte d'utilisateur {accountName} ne correspond pas à ceux des utilisateur enregistre en Ilios. Si vous avez besoin d'aide, n'hesitez pas à communiquer avec votre administrateur  d'Ilios.",
    "noAssociatedCompetencies": "Nul compétences associées",
    "noAssociatedCompetency": "Nul compétence associée",
    "noAvailableCohorts": "Pas des Cohortes disponsibles",
    "noAvailableLearnerGroups": "Pas de groupes d'étudiants sont disponibles; pas de cohorte est attaché à ce cours.",
    "noAvailableLearners": "Pas d'étudiants sont disponibles; pas de cohorte est attaché à ce cours.",
    "noCohorts": "Il n'y a aucun des cohortes dans ce cours",
    "noCohortsAvailableForStudentAssignment": "Il n'y a pas de cohortes disponibles pour l'affectation des étudiants dans cette école.",
    "noCourseLearningMaterialsAvailable": "Aucun Matériels D'étude de Cours",
    "noCourses": "Il n'y a aucun des cours dans cette école.",
    "noCurriculumInventoryInstitutionalInfo": "Aucune information institutionnelle n'a été configurée pour cette école.",
    "noEvents": "aucuns événements",
    "noLearnerGroups": "Pas de groupes des Étudiants",
    "noOfferingLearnerGroups": "Aucun des groupes",
    "noOfferings": "Ce session n'a aucun des offres",
    "noPermissionsInOtherSchools": "Vous n'avez pas les permissions nécessaires pour ajouter cet utilisateur à toute autres écoles",
    "noPopulateGroup": "Non!  Laissez-la vide, j'ajouterai des étudiants moi-même",
    "noPrintDraft": "Cours qui sont au stade de projet ne peuvent pas étre imprimés",
    "noProgramYears": "Il n'y-a pas des années de diplôme dans ca diplôme",
    "noResultsFound": "Aucun résultat n’a été trouvé. Veuillez réessayer.",
    "noSearchResults": "Votre recherche ne retourner pas aucune de resultats",
    "noSearchResultsPrompt": "Aucun Résultat",
    "noSelectedCompetencies": "Il n'y a pas des compétences sélectionné",
    "noSelectedLearnerGroups": "Il n'y a aucune groupes d'apprenants sélectionné",
    "noSequenceBlocks": "Il n'y a aucun blocs séquence dans ce rapport",
    "noSessionLearningMaterialsAvailable": "Aucun Matériels D'étude de Séance",
    "noSessions": "Il n'y a aucun des sessions dans ce cours",
    "noSubSequenceBlocks": "Ce bloc séquence n'y a aucun blocs séquence emboîtée.",
    "noSubgroups": "Il n'éxiste aucune des sous-groupes en cette groupe d'apprenants",
    "noUnselectedCompetencies": "Il n'y a pas des compétences non sélectionné ",
    "noUnselectedLearnerGroupsInCohort": "Il n'y a aucune groupes d'apprenants disponsibles dans cette cohorte",
    "nonClerkshipSequenceBlocks": "Blocs de séquence non stage",
    "nonStudent": "Non étudiant",
    "none": "Nul",
    "notAClerkship": "Pas une stage",
    "notApplicableAbbr": "n.d.",
    "notFoundMessage": "Zut! Je ne pouvais pas trouver cette chôse. S'il vous plaît vérifier votre adresse de la page et essayez à nouveau.",
    "notPublished": "Non Publier",
    "notStarted": "Non Commencé",
    "notes": "Notes",
    "numberOfEvents": "Nombre d'événements",
    "numberOfEventsFeaturingThisAsThePrimaryMethod": "Nombre d'événements avec ceci comme méthode principale",
    "numberOfExams": "Nombre d'examens",
    "numberOfFormalInstructionalHoursPerCourse": "Nombre d'heures d'enseignement formel par cours",
    "numberOfFormativeAssessments": "Nombre d'évaluations formatives",
    "numberOfGroups": "Nombre de groupes",
    "numberOfGroupsToGenerate": "Nombre de groupes pour générer.",
    "numberOfNonPrimaryOccurrencesOfThisMethod": "Nombre d'occurrences non primaires de cette méthode",
    "numberOfSummativeAssessments": "Nombre d'évaluations sommatives",
    "objective": "Objectif",
    "objectiveCompetencyManagerTitle": "Sélectionner Compétence Mère pour Objectif",
    "objectiveCount": "Il y a {count, plural, =1 {1 objectif} other {# objectifs}}",
    "objectiveDescriptorTitle": "Choisi MeSH pour l'objectif",
    "objectiveMap": "Tableau Objectifs",
    "objectiveParentTitle": "Choisi Objectifs mères",
    "objectiveParentTitleSingular": "Choisi Objectif mère",
    "objectiveParentsTitle": "Affichez objectifs mères",
    "objectiveTitle": "Objectif de Séance",
    "objectives": "Objectifs",
    "objectivesWithNoHours": "Les objectifs de cours suivant ne sont ou liés avec aucune séance, ou liés seulement aux séance sans offrir ou ou des données de durée.",
    "objectivesWithNoLink": "Nul objectifs de course actuellement lié au temps dénseignment.",
    "off": "Éteindre",
    "offering": "Offre",
    "offerings": "Offres",
    "ok": "OK",
    "on": "Allumer",
    "openSmallGroupGenerator": "Générateur des petites groupes",
    "optional": "Optionnel",
    "optionalElective": "Optionnel (électif)",
    "orderInSequence": "Ordre dans séquence",
    "ordered": "Ordonnée",
    "other": "Autre",
    "otherId": "Autre ID",
    "otherVisualizations": "Autres Visualisations",
    "overview": "Conception Général",
    "ownedBy": "Possédé par {owner}",
    "owner": "Propriétaire",
    "pagedResultsCount": "Montrant {start} - {end} de {total}",
    "parallel": "Parallèle",
    "parentCount": "{count, plural, =1 {1 a un objectif mère} other {# ont des objectifs mères}}",
    "parentGroup": "Mère groupe",
    "parentGroups": "Mères groupes",
    "parentObjectives": "Objectifs Mères",
    "password": "Mot de passe",
    "pendingUpdatesSummary": "{count, plural, =1 {Il y a un utilisateur nécessitant une attention particulière} other {Il y a des # utilisateurs nécessitants une attention particulière}}",
    "pendingUpdatesSummaryTitle": "Mises du répertoire de Campus",
    "pendingUserUpdates": {
      "emailMismatch": "L’address email dans le répertoire ({value}) ne correspond pas à ce email dans ilios ({email}).",
      "filterBy": "Filtre par nom d’utilisateur",
      "missingFromDirectory": "Impossible de trouver l’utilisateur dans le répertoire, s’il vous plaît mettre à jour, désactiver, ou exclure leur compte de synchronization.",
      "updateIlios": "Mettre à jour Ilios"
    },
    "people": "Peuples",
    "perPage": "Par Page",
    "percentage": "Pourcentage",
    "performsNonLearnerFunctions": "Acquitte de Fonctions Non-Apprenant",
    "permissions": "Permissions",
    "permissionsInOtherSchools": "Permissions en Autres Écoles",
    "phasesStartToEnd": "Phases (début - fin)",
    "phone": "Téléphone",
    "physicianCompetencyReferenceSet": "Ensemble de références de compétences de médecin",
    "physicianCompetencyReferenceSetAbbr": "PCRS",
    "pickADate": "Choisis une date",
    "populateGroup": "Voulez-vous remplir cette groupe?",
    "preWork": "Préalable",
    "preferredEmail": "Email préféré",
    "prerequisites": "Conditions préalables",
    "prev": "Précéd.",
    "previous": "Antérieur",
    "primary": "Première",
    "primaryCohort": "Cohorte Première",
    "primarySchool": "École Première",
    "printSummary": "Empreinte Résumé",
    "program": "Diplôme",
    "programAndCohort": "Diplôme et Cohortes",
    "programCohorts": "Cohortes",
    "programDetail": "Détail du programme",
    "programExpectations": "Attentes du programme",
    "programExpectationsId": "Identifiant des attentes du programme",
    "programLeadership": "Direction de Diplôme",
    "programTitle": "Titre de Diplôme",
    "programTitleFilterPlaceholder": "Filtre par Titre de Diplôme",
    "programTitlePlaceholder": "Ajoutez un titre pour ce Diplôme",
    "programTitleShort": "Titre (bref)",
    "programYear": "Année de Diplôme",
    "programYearLeadership": "Direction de l'Année de Diplôme",
    "programYearVisualizations": "Tableau de Matière de Curriculum par Année de Diplôme",
    "programYears": "Années des Diplôme",
    "programs": "Diplômes",
    "promoteToPrimaryCohort": "Promouvoir à Cohorte Primaire",
    "pronouns": "Pronom",
    "publicationStatus": "Statut de Publication",
    "publishAllConfirmation": "Publier {publishCount}, réserver {scheduleCount}, et ignorer des {ignoreCount} séances",
    "publishAllSessions": "Publier {sessionCount} des séances",
    "publishAsIs": "Publier \"as-is\"",
    "publishCourse": "Publier Cours",
    "publishProgram": "Publier Diplôme",
    "publishProgramYear": "Publier année de diplôme",
    "publishSession": "Publier Session",
    "published": "Publier",
    "publishedSuccessfully": "Publier réussi",
    "read": "Lecture",
    "reconnectNow": "Reconnecter Maintenant",
    "reconnectionSeconds": "{count, plural, =1 {Reconnexion en 1 seconde...} other {Reconnexion en # secondes...}}",
    "refreshIcsFeedKey": "Rafraîchissez la données de ICS clef pour cet utilisateur",
    "refreshTheBrowser": "Rafraîchir votre Navigateur",
    "remove": "Supprîme",
    "removeAll": "Supprimer Tous",
    "removeCohort": "Supprîmer Cohorte",
    "removeLearnerToCohort": "{count, plural, =1 {Renvoyer l’étudiant à {cohort}} other {Renvoyer # étudiants à {cohort}}}",
    "removePrimaryCohort": "Supprîmer Cohorte Primaire",
    "removedSuccessfully": "Supprimé avec succès",
    "reportConfirmRemove": "Êtes-vous sûrs que vous voulez supprimer ce rapport? Cette action ne peut pas être défaite.",
    "reportDescriptionPlaceholder": "Entrez S'il vous plaît dans une description brève de ce rapport.",
    "reportDisplayDescriptionWithObject": "This report shows all {subject} associated with {objectType} \"{object}\" {year} in {school}.",
    "reportDisplayDescriptionWithoutObject": "Ce rapport montre tous les {subject} de {school}.",
    "reportDisplayTitleWithObject": "tous {subject} pour {object} en {school}",
    "reportDisplayTitleWithoutObject": "tous {subject} en {school}",
    "reportName": "Nom de rapport",
    "reportNamePlaceholder": "Entrez S'il vous plait un nom de rapport.",
    "reportTitle": "Titre du Rapport",
    "reports": "Rapports",
    "required": "Requis",
    "requiredInTrack": "Requis en piste",
    "resourceTypes": "Types de ressources",
    "results": "Resultats",
    "resultsCount": "{count, plural, =1 {1 résultat} other {# résultats}}",
    "returnToPreviousPage": "Retour à la page précédente",
    "reviewMissingItems": "Examiner {count} objets manquants",
    "reviewSessions": "Séances à faire réviser",
    "root": "Root",
    "runReport": "exécuter le rapport",
    "sampleFile": "Fichier échantillon",
    "saturday": "Samedi",
    "save": "Enregistrer",
    "saved": "Nouvel utilisateur enregistré avec succès",
    "savedSuccessfully": "Réussie Sauvé",
    "scheduled": "Prevu",
    "scheduledSuccessfully": "Faire à prévu réussi",
    "scheduling": "Planification",
    "school": "Écôle",
    "schoolName": "Nom de l'école",
    "schools": "Écôles",
    "search": "Rechercher",
    "searchDirectory": "Consultez le répertoire pour les utilisateurs nouvels",
    "searchForIliosUsers": "Trouver des utilisateurs...",
    "searchMesh": "Rechercher MeSH",
    "searchPlaceholder": "Trouver matériels d'étude",
    "searchTheCurriculum": "Rechercher le curriculum",
    "searchUsers": "Rechercher des utilisateurs",
    "secondaryCohorts": "Cohortes Secondaires",
    "select": "Sélectionnez",
    "selectAcademicYear": "Choisissez l’année scolaire",
    "selectAllOrNone": "Sélectionner tout ou aucun",
    "selectCohortsToAttach": "Choisissez le cohorte d'étudiants que vous voulez attacher au cours nouveau",
    "selectCourse": "Choisi cours",
    "selectMeshFor": "Sélectionnez MeSH pour: {title}",
    "selectPolite": "(veuillez en sélectionner un)",
    "selectProgram": "Choisi Diplôme",
    "selectSchool": "Choisi Écôle",
    "selectUser": "Choisi l'utilisateur",
    "selectVocabulary": "Choisi Vocabulaire",
    "selectYear": "Choisi année scolaire",
    "selected": "Sélectionné",
    "selectedInstructorGroups": "Groupes d’Instructeurs Selectionées",
    "selectedInstructors": "Instructeurs Selectionées",
    "selectedLearnerGroups": "Groupes d’Étudiants Selectionées",
    "selectedLearners": "Étudiants Selectionées",
    "sequenceBlock": "Bloc séquence",
    "sequenceBlockConfirmRemove": "Êtes-vous sûrs que vous voulez supprimer ce bloc séquence? Cette action ne peut pas être défaite.",
    "sequenceBlockDescriptionPlaceholder": "Entrez S'il vous plaît dans une description pour ceci bloc séquence.",
    "sequenceBlockIsSelective": "Cette bloc séquence a été marquée comme sélective.",
    "sequenceBlockTitlePlaceholder": "Entrez S'il vous plaît dans une titre pour ceci bloc séquence.",
    "sequenceBlocks": "Blocs séquence",
    "sequenceNumber": "No. de séquence",
    "session": "Séance",
    "sessionAttributes": "Attributs de Séance",
    "sessionLearningMaterials": "Matériels d'Étude de la Séance",
    "sessionTitle": "Titre de Séance",
    "sessionTitleFilterPlaceholder": "Filtre par titre, genre, ou statut",
    "sessionTitlePlaceholder": "Ajoutez un titre pour ce session",
    "sessionType": "Type de Séance",
    "sessionTypeConfirmRemoval": "Voulez-vous vraiment supprimer ce type de session ? Cette action ne peut pas être annulée.",
    "sessionTypes": "Types de Séance",
    "sessionTypesFor": "Types de Séance par {subject}",
    "sessions": "Séances",
    "showAllMyActivities": "Afficher toutes mes activités",
    "showCalendar": "Afficher Calendrier",
    "showCourseMaterials": "Afficher les supports de cours",
    "showFilters": "Montrez les Filtres",
    "showIcsFeed": "Afficher les options d'alimentation ICS",
    "showLearnerGroupEvents": "Montrez tous les événements pour les groupes d'étudiants affectés",
    "showMore": "Afficher plus",
    "showNotesToStudents": "Afficher notes aux étudiantes",
    "showObjectives": "Afficher les objectifs",
    "showOnlyMyAdminActivities": "Afficher uniquement mes activités d'administrateur",
    "showOnlyMyInstructorActivities": "Afficher uniquement mes activités d'instructeur",
    "showOnlyMyLearnerActivities": "Afficher uniquement mes activités d'apprenant",
    "showResultsFor": "Afficher les résultats pour",
    "showRolesInCourses": "Afficher les rôles dans les cours",
    "showRolesInProgramYears": "Afficher les rôles dans les années du programme",
    "showRolesInPrograms": "Afficher les rôles dans les programmes",
    "showRolesInSessions": "Afficher les rôles dans les sessions",
    "showSessionEvents": "Montrez tous les autres '<em>'{sessionTitle}'</em>' événements",
    "showSessionMaterials": "Afficher les supports de session",
    "showSubgroupEvents": "Afficher les événements pour tous les sous-groupes",
    "singleDay": "Seule Journée",
    "singleGroup": "Seul groupe",
    "skipToMainContent": "passer au contenu principal de la page",
    "smallGroupMessage": "S'il vous plaît choisir au moins un groupe d'apprenants à joindre à votre offrande de \"small groups\". Si vous souhaitez programmer cette offrande sans groupes, s'il vous plaît choisir le bouton \"offre\" au-dessus.",
    "smallGroups": "Groupes Particulaires",
    "sortMaterials": "Trier les matériaux",
    "sortObjectives": "Trier les objectifs",
    "specialAttireIs_Required_": "Vêtements particuliers est '<strong><em>'requis'</em></strong>'",
    "specialAttireRequired": "Vêtements particuliers requis",
    "specialEquipment": "Équipage particulier",
    "specialEquipmentIs_Required_": "Équipage particulier est '<strong><em>'requis'</em></strong>'",
    "specialEquipmentRequired": "Équipage particulier requis",
    "start": "Commencer",
    "startDate": "Jour Commencer",
    "startLevel": "niveau de départ",
    "startOver": "recommencer",
    "startTime": "Heure Commencer",
    "starts": "Commencer",
    "stateOrProvince": "État ou province",
    "status": "Statut",
    "statusCode": "Code d'état",
    "stewardingSchoolsAndDepartments": "Écôles et Départements intendants",
    "stewardsManageTitle": "Manager des intendants",
    "street": "Rue",
    "strong": "Fort",
    "student": "Étudiant",
    "studentAdvisorCount": "Il y a {count, plural, =1 {une camarade-conseil} other {# camarades-conseil}}",
    "studentAdvisors": "Camarades-Conseil",
    "subCompetencyCount": "{count, plural, =1 {Il y a 1 sous-subcompétence} other {Il y a de # sous-subcompétences}}",
    "subTerms": "Sous-termes",
    "subgroupName": "nom de sous-groupe",
    "subgroups": "Sous-groupes",
    "subjectReports": "Rapports Pédagogiques",
    "successfullyAddedTerm": "Le terme soit correctement ajouté",
    "successfullyInvalidatedTokens": "Tous les jetons existant ont été invalidés avec succès.",
    "successfullyRemovedTerm": "Le terme soit correctement supprimé",
    "summary": "Résumé",
    "sunday": "Dimanche",
    "supplementalCurriculum": "Supplemental Curriculum",
    "table1ProgramExpectationsMappedToPcrs": "Tableau 1: Attentes du programme mappées sur le PCRS",
    "table2PrimaryInstructionalMethodByNonClerkshipSequenceBlock": "Tableau 2: Méthode d'instruction primaire par bloc de séquence non stage",
    "table3aNonClerkshipSequenceBlockInstructionalTime": "Tableau 3-A: Durée d'instruction du bloc de séquence non stage",
    "table3bClerkshipSequenceBlockInstructionalTime": "Tableau 3-B: Temps d'instruction du bloc de séquence de stage",
    "table4InstructionalMethodCounts": "Tableau 4: Nombre de méthodes pédagogiques",
    "table5NonClerkshipSequenceBlockAssessmentMethods": "Tableau 5: Méthodes d’évaluation du bloc de séquence non stage",
    "table6ClerkshipSequenceBlockAssessmentMethods": "Tableau 6: Méthodes d’évaluation du bloc de séquences stage",
    "table7AllEventsWithAssessmentsTaggedAsFormativeOrSummative": "Tableau 7: Tous les événements avec des évaluations marquées en tant que formatif ou sommatif",
    "table8AllResourceTypes": "Tableau 8: Tous les types de ressources",
    "targetCourse": "Cours Cible",
    "taughtBy": "Dispensé à {instructors}",
    "term": "Terme",
    "termCount": "{count, plural, =1 {1 on a des termes de vocabulaire} other {# ont des termes de vocabulaire}}",
    "termXappliedToYSessionsWithSessionTypeZ": "Le terme \"{term}\" du vocabulaire \"{vocabulary}\" s'applique à {sessionsCount, plural, =1 {1 session} other {# sessions}} avec le type de session \"{sessionType}\".",
    "terms": "Termes",
    "termsBySessionType": "Termes par Type de Seance",
    "termsManageTitle": "Manager des Termes",
    "thereAreXTerms": "{count, plural, =1 {Il y a 1 terme} other {Il y a # termes}}",
    "thereAreXTypes": "{count, plural, =1 {Il y a 1 type} other {Il y a # types}}",
    "thisReportIsNoLongerAvailable": "Ce rapport n'est plus disponsible.",
    "thisTermHasSubTerms": "Ce terme a des sous-termes.",
    "thursday": "Jeudi",
    "time": "Temps",
    "timedRelease": "Période Limitée",
    "timedReleaseAddEndDate": "Ajouter la date limite",
    "timedReleaseAddStartDate": "Ajouter la date de début",
    "timedReleaseClearEndDate": "Supprimer la date limite",
    "timedReleaseClearStartDate": "Supprimer la date de début",
    "timedReleaseNoSchedule": "Disponible immédiatement quand publié",
    "timedReleaseOnlyEndDate": "Disponible avant {endDate}",
    "timedReleaseOnlyStartDate": "Disponible après {startDate}",
    "timedReleaseStartAndEndDate": "Disponible de {startDate} jusqu'à {endDate}",
    "timezone": "Fuseau horaire",
    "title": "Tître",
    "today": "Aujourd'hui",
    "token": "Token",
    "tokenInfo": "Jetons de l’API sont utilisés d’y accèder les données de Ilios.  Votre jeton comme un mot de passe: quiconque l’obtenu pouvent apporter des modifications en votre nom.  Lire plus dans les documentation à {apiDocsLink}.",
    "tooManyResults": "Votre recherche présente plus que les {count} resultats. Pour meilleurs de resultats, essayez votre recherche encore avec plus termes.",
    "topPagination": "Pagination supérieure",
    "total": "Total",
    "totalErrors": "{count, plural, =1 {Il y a une erreur} other {Il y a # erreurs}}",
    "totalIlmTime": "Durée totale par ILM {minutes} Minutes",
    "totalInstructionalTime": "Durée d'enseignement totale {minutes} Minutes",
    "totalTime": "Heures Totales",
    "totalWeeks": "Total de Semaines",
    "transitionErrorMessage": "Désolé, nous ne pouvons pas vous faire demander où vous aller : quelque chose semble être cassé.",
    "tryHarder": "Faire un effort",
    "tuesday": "Mardi",
    "type": "Type",
    "unPublishCourse": "Faire à Dépublier Cours",
    "unPublishProgram": "Faire à Dépublier Diplôme",
    "unPublishProgramYear": "Faire à Dépublier année de diplôme",
    "unPublishSession": "Faire à Dépublier Session",
    "unPublishedSuccessfully": "Faire à Dépublier réussi",
    "unableToReconnect": "Ne pouver reconnecter!",
    "unableToSyncUser": "Incapable de syncroniser le utilisateur de répertoire, veuillez vous assurer le campus ID soit exacte.",
    "unassigned": "Non attribuée",
    "unassignedStudentsConfirmation": "{count, plural, =1 {Attribuez 1 l’utilisateur sélectionné à} other {Attribuez # utilisateurs sélectionnés à}}",
    "unassignedStudentsSummary": "{count, plural, =1 {Il y a un étudiant qui a besoin affectation à une cohorte} other {Il y a # étudiants qui ont besoin affectation à une cohorte}}",
    "unassignedStudentsSummaryTitle": "Étudiants qui ont besoin affectation à une cohorte",
    "undo": "Defaît",
    "universalLocator": "Localisateur universel",
    "unlinkedObjectives": "Ce cours comprend des objectifs non liés",
    "unlockCourse": "Débloquer le cours",
    "unordered": "Non ordonnée",
    "unsupportedBrowserFailure": "Votre navigateur n'est pas officiellement soutenu par Ilios et ne peut pas compléter cette action. Essayez S'il vous plaît d'utiliser de nouveau un navigateur à jour.",
    "unusedObjectives": "Objectifs non Utilisés",
    "upcomingActivities": "Mes Activités pendant les {days} prochains jours",
    "upcomingMaterials": "Mes Matériels d'Étude pendant les {days} prochains jours",
    "update": "mettre à jour",
    "updateNow": "Actualiser affichage",
    "updatePending": "Mise à jour en suspens",
    "updateUserFromDirectory": "Mettez à jour cet enregistrement utilisateur de la répertoire de campus",
    "uploadDate": "Date de dépôt",
    "uploadGroupAssignments": "téléversez travaux des groupes",
    "uploadUsers": "fichier de donnée utilisateurs (csv, tsv, txt)",
    "uploadedGroup": "groupe a été téléversée",
    "url": "URL",
    "userExistsInGroupHierarchy": "L'utilisateur existe déjà dans le groupe de niveau supérieur {groupTitle} ou dans l'un de ses sous-groupes.",
    "userExistsMultipleTimesInUpload": "Cet utilisateur existe déjà dans le téléchargement.",
    "userMenu": "Menu utilisateur",
    "userNotAddableFromDirectory": "Cette utilisateur manque les informations requises, et ne peut pas être ajouté",
    "userNotInGroupCohort": "utilisateur introuvable dans cette groupe de cohorte: {cohortTitle}",
    "userRole": "Rôle d'utilisateur",
    "userRoles": "Rôles des Utilisateurs",
    "username": "Nom d'utilisateur",
    "users": "Utilisateurs",
    "usersCalendar": "Calendrier de {name}",
    "usersSelected": "{count, plural, =1 {1 utilisateur sélectionné} other {# utilisateurs sélectionnés}}",
    "validUntil": "Quand ce jeton devrais arrêter de travailler?",
    "validUsers": "utilisateurs valides",
    "verificationPreviewFor": "Aperçu de vérification pour {name}",
    "view": "Vue",
    "viewAll": "Voir Tous",
    "virtualLearningLink": "Address d’Étude Virtuel",
    "virtualSessionLink": "Lien de Séance Virtuelle",
    "visibleToStudents": "Visible pour les étudiants",
    "visualizations": "Visualisations",
    "visualizeCourseObjectives": "Visualiser les objectifs du cours ",
    "vocabularies": "Vocabulaires",
    "vocabulariesBySessionType": "Vocabulaires par Type de Seance",
    "vocabulary": "Vocabulaire",
    "vocabularyTerms": "Termes Vocabulaire",
    "vocabularyTermsFor": "Termes Vocabulaire par {subject}",
    "waitSaving": "Travaille dessus... un moment...",
    "weak": "Faible",
    "wednesday": "Mercredi",
    "week": "Semaine",
    "weekAtAGlance": "Semaine d'un coup d'œil",
    "weekOf": "Semaine de {date}",
    "weeks": "Semaines",
    "when": "Quand",
    "whichIs": "qui est",
    "whitecoatsSlashSpecialAttire": "Blouses blanches / vêtements particuliers",
    "withXmoreOfferings": "avec {count, plural, =1 {une autre offre} other {# autres offres}}",
    "write": "Écriture",
    "xTermsFromVocabYusedWithSessionTypeZ": "{termsCount, plural, =1 {1 term} other {# termes}} du vocabulaire \"{vocabulary}\" {termsCount, plural, =1 {est appliqué} other {sont appliqués}} à {sessionsCount, plural, =1 {1 session} other {# sessions}} avec le type de session \"{sessionType}\".",
    "year": "Année",
    "yes": "Oui",
    "yesPopulateGroup": "Oui!  Ajoutez la cohorte entière à mon nouveau groupe",
    "zipCode": "Code postal"
  }
}]];